
import React, { useEffect, useState, useContext, useRef } from "react";
import ReactDOM from "react-dom";
import {
    BrowserRouter,
    useNavigate,
    Route,
    Routes,
    useParams,
    useSearchParams,
} from "react-router-dom";

import { fetchJson, fetchStaticJson } from "../fetch.js";
import { currency, isLibraryUser, isEntitled, isInternal, isForSchoolBasket, imageURLPrefix, IsBooksForTopic, getStockMessage, creatorsFromSource, decodeHTML, slugify } from "../helpers.mjs";
import { PubSub } from '../weave/helpers.mjs';
import '../main.mjs';
import LoadingSpinner from "../components/loadingSpinner.mjs";
import Cookies from "js-cookie";
import { AddEntityModal, Modal, notifyLoading, openModal, closeModal, stopNotifyLoading, notifyError } from "../modal.js";
import BookPage from '../bookpage/BookPage.js';
import { SearchContext } from "../components/SearchContext.js";
import AddToBasket from "../bookpage/AddToBasket.js";
import AwardBadge from "../components/AwardBadge.js";
import Creators from "../components/Creators.js";
import OfferLink from '../bookpage/OfferLink.js';
import BulkDiscountsTable from '../bookpage/BulkDiscountsTable.js';
import BookTitle from '../bookpage/BookTitle.js';
import BookPackCollage from"../components/BookPackCollage.js";
import BookPackOriginatorLink from "../components/BookPackOriginatorLink.js";
import { showRatings, pubAssessmentScore, getBookBands } from "../bookpage/helpers.js";
import ClassSetOverlay from "../components/ClassSetOverlay.js";
import axios from "axios";

window.ajax = "";

// bundled rather than relying on window.bindings, which BookInfo.js only fills in once its fetch completes
const bindings = require('../../json/bindings.json');
const broadbindings = require('../../json/broadBindings.json');
const languages = require('../../json/languages.json');

const getImage = (ean) => {
    const imageFolder = ean.substring(ean.length - 3);
    const fullLink = `${imageURLPrefix()}/covers/large/${imageFolder}/${ean}.jpg`;

    return fullLink;
}

const getSearchViewType = (updatedGridView) => {
    const cookieViewType = Cookies.get('searchViewType');
    if (cookieViewType) {
        return cookieViewType;
    }

    return (updatedGridView && window.matchMedia("(max-width: 768px)").matches) ? "grid" : "list";
}

// fetchJson("/assets/json/bindings.json").then(r => {
//     window.bindings = r;
// });
// fetchJson("/assets/json/broadBindings.json").then(r => {
//     window.broadbindings = r;
// });
// fetchJson("/assets/json/languages.json").then(r => {
//     window.languages = r;
// });

// const Thema = ({thema, searchThema}) => {
//     if (thema === null) return null;
//     const t = thema.split(",");

//     return <>
//         {t.map(c => {
//             var d;
//             if (window.themaCodes[c]) {
//                 d = window.themaCodes[c].description;
//             }
//             return <span><a onClick={(e) => {e.preventDefault(); searchThema(c)}}>{d ? d : c}</a> | </span>;
//         })}
//     </>
// }

const GridBadges = ({ hit }) => {
    const r = hit._source;
    const productId = r.product_id;
    const { extraData, doCustomSearch } = useContext(SearchContext);
    return (
        <div className="gridBadgeImage">
            {/* {r.isbookpack == 1 && <img className="bookBadge bookPack" src="/assets/img/bookpackbadgesmall.png" alt="Book pack" />} */}
            {r.is_recommended_read === true && <img className="bookBadge recommendedRead" src="/assets/img/recreadssmall.png" alt="Recommended read" title="Recommended read" />}
            {r.is_book_of_the_week === true && <img className="bookBadge bookOfTheWeek" src="/assets/img/bookoftheweeksmall.png" alt="Book of the week" title="Book of the week" />}
            {extraData && extraData[productId] && extraData[productId].offerGroupId && <a href="#" onClick={e => {
                e.preventDefault();
                doCustomSearch([{ "filter": `filters[groupOffers][${extraData[productId].offerGroupId}][checked]`, "value": "1" }]);
            }}><img className="bookBadge offers" src="/assets/img/specialOffersBadge.png" alt={extraData[productId].offerGroupName} title={extraData[productId].offerGroupName} /></a>}
            {r.downloadable_resource_type && <a href={`/book-page/${r.id}#resources`}>
                <img className="bookBadge downloadableResources" height="30px" width="30px" src="/assets/img/resourcesmail.png" alt="Downloadable resource available" title="Downloadable resources available" />
            </a>}
            {r.advisory === true && <img className="bookBadge contentAdvisory" src="/assets/img/contentwarning.png" title={r.advisory_note} />}
            {r.awards_won && r.awards_won.map((a, i) =>
                <AwardBadge key={i} award={a} placement="Winner" small={true} />
            )}
            {r.awards_short && r.awards_short.filter(a => r.awards_won === null || !r.awards_won.includes(a)).map((a, i) =>
                <AwardBadge key={i} award={a} placement="Shortlisted" small={true} />
            )}
            {r.is_bestseller === true && <BestsellerBadge productId={productId} small={true} />}
            {r.keywords && r.keywords.some(k => k.value === '1324') && <p className={'debutAuthorTitle carouselBadgeHeader searchBadge'} title='Debut author/illustrator'>
                <i className='fas fa-star-exclamation'></i>
            </p>}
        </div>
    )
}

const BestsellerBadge = ({ productId, small }) => {
    const { bestsellersByProduct } = useContext(SearchContext);
    const bestseller = bestsellersByProduct[productId];
    if (!bestseller) {
        return null;
    }
    return (
        <p className={'bestSellersTitle carouselBadgeHeader' + (small ? ' searchBadge' : '')} title={'Highest position: #' + bestseller.rank + ' on ' + bestseller.startDate}>
            <i className='fas fa-chart-line'></i>{(!small ? <span><strong>Bestseller</strong></span> : "")}
        </p>
    )
};

const Badges = ({ hit }) => {
    const r = hit._source;
    const { doCustomSearch } = useContext(SearchContext);
    let debutAuthor = false;
    var num = 0;
    if (r.isbookpack == 1) num++;
    if (r.is_recommended_read === true) num++;
    if (r.is_book_of_the_week === true) num++;
    if (r.downloadable_resource_type) num++;
    if (r.advisory === true) num++;
    num += ((r.awards_won ? r.awards_won.length : 0) + (r.awards_short ? r.awards_short.length : 0));
    if (r.is_bestseller === true) num++;
    if (r.keywords && r.keywords.some(k => k.value === '1324')) {
        debutAuthor = true;
        num++;
    }
    const usesmall = num > 2;

    return (
        <div className={"imageBadgeContainer" + (usesmall ? " flexBadges" : "")}>
            {r.is_recommended_read === true && <span><img className="bookBadge recommendedRead" src={"/assets/img/" + (usesmall ? "recreadssmall.png" : "recommendedReadsBadge.png")} alt="Recommended read" title="Recommended read" /></span>}
            {r.is_book_of_the_week === true && <span><img className="bookBadge bookOfTheWeek" src={"/assets/img/" + (usesmall ? "bookoftheweeksmall.png" : "bookbold.png")} alt="Book of the week" title="Book of the week" /></span>}
            {/* {r.isbookpack == 1 && <span><img className="bookBadge bookPack" src={"/assets/img/bookpackbadge" + (usesmall ? "small.png" : ".png")} alt="Book pack" /></span>} */}
            {r.downloadable_resource_type && <a href={`/book-page/${r.id}#resources`}>
                <img className="bookBadge downloadableResources" height="38px" width="231px" src={"/assets/img/" + (usesmall ? "resourcesmail.png" : "resourcesBadge.png")} alt="Downloadable resource available" title="Downloadable resources available" />
            </a>}
            {r.advisory === true && <span ><img className="bookBadge contentAdvisory" src={"/assets/img/" + (usesmall ? "contentwarning.png" : "contentwarningwords.png")} alt="Content Advisory" title={r.advisory_note} /></span>}
            {r.awards_won && r.awards_won.map((a, i) =>
                <AwardBadge key={i} award={a} placement="Winner" small={usesmall} />
            )}
            {r.awards_short && r.awards_short.filter(a => r.awards_won === null || !r.awards_won.includes(a)).map((a, i) =>
                <AwardBadge key={i} award={a} placement="Shortlisted" small={usesmall} />
            )}
            {r.is_bestseller === true && <BestsellerBadge productId={r.product_id} small={usesmall} />}
            {debutAuthor && <p className={'debutAuthorTitle carouselBadgeHeader' + (usesmall ? ' searchBadge' : '')} title='Debut author/illustrator'>
                <i className='fas fa-star-exclamation'></i>{(!usesmall ? <span><strong>Debut</strong></span> : "")}
            </p>}
        </div>
    )
}

// const CreatorLink = ({creator, type, typeD, noLink=false}) => {

//     const {doSearchTermSearch} = useContext(SearchContext);

//     if(noLink) {
//         return <>
//             {type != "other" && <span>{creator}{typeD != "Author" && <> ({typeD})</>}</span>}
//             {type == "other" && <span>{creator}</span>}
//         </>
//     } else {
//         return <>
//             {type != "other" && <p className="authorsLink" onClick={() => {
//                 doSearchTermSearch(creator, type);
//             }}>{creator}{typeD != "Author" && <> ({typeD})</>}</p>}
//             {type == "other" && <span>{creator}</span>}
//         </>
//     }
// }

// const CreatorLink = ({ creator, type, typeD }) => {
//     const { doSearchTermSearch } = useContext(SearchContext);

//     return <>
//         {type != "other" && <a href="#" onClick={() => {
//             doSearchTermSearch(creator, type);
//         }}>{creator}{typeD != "Author" && <> ({typeD})</>}</a>}
//         {type == "other" && <span>{creator}</span>}
//     </>
// }

const BookDetails = ({ hit, creators, dense }) => {
    const r = hit._source;
    const productId = r.product_id;

    const navigate = useNavigate();
    const { doSearchTermSearch, goToResult, extraData, updatedGridView } = useContext(SearchContext);

    var binding = "";
    if (r.binding && (bindings[r.binding] == "Board book" || bindings[r.binding] == "Board")) {
        binding = "Board book";
    } else if (r.binding && bindings[r.binding] == "Spiral") {
        binding = "Spiral bound";
    } else if (r.broad_binding && broadbindings[r.broad_binding] != "Other") {
        binding = broadbindings[r.broad_binding];
    } else if (r.binding == 'PK' && r.distributor.value == "9ZZ8") {
        binding = "Peters pack";
    } else if (r.binding) {
        binding = bindings[r.binding];
    }

    const bookBand = r.productcategorylinks ? r.productcategorylinks.filter(c => bookBands[c]).map(c => c) : "";

    const bookbandsArray = r.productcategorylinks ? r.productcategorylinks.filter(c => bookBands[c]).map((c, i) => <li key={i}><span value={[c]} className={`listPageCircle swatch cat${c}`} title={bookBands[c]}></span></li>) : [];

    // const bookbandsArray = r.productcategorylinks ? r.productcategorylinks.filter(c => bookBands[c]).map(c => <li><span className={`listPageCircle swatch cat${c}`} title={bookBands[c]}></span></li>) : [];

    // Check bib text -> if bib text exceeds character length, add ellipsis?
    const bibText = (r.bib_tag && r.bib_tag !== "" && r.bib_tag?.length > 275) ? (r.bib_tag.substring(0, 275).trim() + "...") : r.bib_tag;

    var publishdatetext = null;
    if (r.publish_date) {
        var publishdate = new Date(r.publish_date);
        publishdatetext = `published ${publishdate.toLocaleDateString('default', { month: "long" })} ${publishdate.getFullYear()}`;
    }

    var languageArray = [];
    if (r.language != null) {
        languageArray = r.language?.filter(l => (l.value != "E" && l.value != "eng")).map(l => l.title);
    }

    // const hasAuthor = r.authors && r.authors?.length > 0;

    const showeval = showRatings(r);

    var editionTooltip = "";
    if (r.edition && r.edition != "") {
        switch (r.edition) {
            case "Bind-up":
            case "Bind-Up":
                editionTooltip = "Multiple titles published in a single volume, where each title has been previously published alone.";
                break;
            case "First":
                editionTooltip = "Not previously published, available for the first time with a hardback cover";
                break;
            case "Import":
            case "Import - New in UK":
                editionTooltip = "Originally published outside of the UK";
                break;
            case "Large":
                editionTooltip = "Giant size, used for group storytelling or sharing";
                break;
            case "Large Print":
                editionTooltip = "Set in large type (such as 18 point or larger), especially for use by the partially sighted";
                break;
            case "New":
                editionTooltip = "Previously available but the information has been updated or reworked, or the basic format has changed";
                break;
            case "New Cover Reprint":
                editionTooltip = "Reissued with a new ISBN and a new cover, but no changes to content";
                break;
            case "New in Paperback":
            case "New in paperback":
                editionTooltip = "Previously published as a hardback, now available in a paperback format for the first time";
                break;
            case "Original":
                editionTooltip = "Not previously published, available for the first time with a paperback cover";
                break;
            case "Reprint":
                editionTooltip = "Reissued with a new ISBN, with no changes to the content";
                break;
            case "Rights Reversion":
                editionTooltip = "New edition as the publishing rights have transferred back to the author, or to a new publisher";
                break;
            case "Simultaneous":
                editionTooltip = "Not previously available, published in two formats at the same time (usually hardback and paperback)";
                break;
            default:
                break;
        }
    }
    const peEditionTooltip = editionTooltip;

    const assessmentScore = pubAssessmentScore(r);

    let publisherToDisplay = (r.imprint?.title != "UNKNOWN" && r.imprint?.title != "") ? r.imprint.title : (r.publisher ? r.publisher.title : "");

    publisherToDisplay == "UNKNOWN" ? publisherToDisplay = "" : publisherToDisplay = publisherToDisplay;

    return (<>
        {!dense && <div className="bookTitle">
            <a className="blue" onClick={(e) => {
                e.preventDefault();
                goToResult(r.id);

            }}>
                <BookTitle source={r} />
            </a>
        </div>}
        {!dense && <div className="bookAuthor allCreators">
            <Creators source={r} />
        </div>}
        {/* gallery view only - illustrators left out so the author fits on one line */}
        {!dense && updatedGridView && <div className="bookAuthor gridAuthor">
            <Creators source={r} exclude={["ill"]} commasOnly={true} />
        </div>}
        {!dense && !r.isbookpack && <div className="bookSeries">
            {r.series_display && <a className="blue" href="#" onClick={e => {
                e.preventDefault();
                doSearchTermSearch(`"${r.series_display}"`, "series");
            }}>{r.series_display}{!!r.volume && <> ({r.volume})</>}</a>}
        </div>}
        {isLibraryUser() && <div className="bookBinding libDetails">
            {extraData && extraData[productId] && extraData[productId].opacLink && <a target="_blank" title="Open in your OPAC" href={extraData[productId].opacLink}>{r.id}</a>}
            {(!extraData || !extraData[productId] || !extraData[productId].opacLink) && <>{r.id}</>}
            {publisherToDisplay != "" && <span> | <a href="#" onClick={e => {
                e.preventDefault();
                doSearchTermSearch(publisherToDisplay, "pub");
            }}>{publisherToDisplay}</a></span>}
            {r.edition && r.edition != "" && <span> | <p className="needMore">{r.edition} {peEditionTooltip !== "" && <span className="searchToolTip">{peEditionTooltip}</span>}</p></span>}
        </div>}
        {r.broad_binding && <div className="bookBinding">
            {binding != "" && <strong>{binding}</strong>}
            {publishdatetext && !r.isbookpack && <span className="publishDate"> ({publishdatetext})</span>}
        </div>}
        <div className="bookDetails">
            {isEntitled() && <ul className="bookProperties">
                {r.dewey && <li className="productDewey">
                    <span className="deweyLabel">Dewey:&nbsp;</span>
                    <span className="deweyValue">{r.dewey}</span>
                    {extraData && extraData[productId] && extraData[productId].customerDewey && extraData[productId].customerDewey != "" && <span className="deweyValue"> | {extraData[productId].customerDewey}</span>}
                </li>}

                {(r.book_level > 0 || r.ar_interest_level > 0) &&
                    <ARBookLevelLink bookLevel={r.book_level} interestLevel={r.ar_interest_level} />
                }

                {bookbandsArray.length > 0 &&
                    <BookBandLink bookBand={bookBand} bookbandsArray={bookbandsArray} />
                }

                {(r.phonic_phase_level) &&
                    <PhonicPhaseLink phonicPhase={r.phonic_phase_level} />
                }

                {isInternal() && !isLibraryUser() && r.id && <li className="ean13">
                    {r.id}
                </li>}
            </ul>}
            {!dense && (isEntitled() || r.isbookpack) && bibText !== null && <div className="bookReview bibText">{bibText}</div>}
            {!dense && <div className="row">
                {isLibraryUser() && assessmentScore > 0 && <div className="column qualityMetricTextContainer" title={"Predicted popularity: " + assessmentScore + "/10"}>
                    <div className="qualityMetricText">{assessmentScore}/10</div>
                </div>}
                {/* {isLibraryUser() && <div className="column libSuitDisplay" title={"Suitability for libraries:\n" + LIBRARY_SUITABILITY[r.suit_libraries]}>
                    {r.suit_libraries == 3 && <span><img src="/assets/img/bookicon4-checked.png" /></span>}
                    {r.suit_libraries == 2 && <span><img src="/assets/img/bookicon2-checked.png" /></span>}
                    {r.suit_libraries == 1 && <span><img src="/assets/img/bookicon-checked.png" /></span>}
                    {r.suit_libraries == 0 && showeval && <span><img src="/assets/img/bookicon-nochecked.png" /></span>}
                </div>}
                {isEntitled() && isLibraryUser() && r.evaluation && r.distributor.value != 'ZZ89' && <div className="rating ratingwidth lineItem" title={"Suitability for schools:\n" + SCHOOL_SUITABILITY[r.suit_schools]}>
                    <span className={r.suit_schools == 3 ? "checked" : ""}><label></label></span>
                    <span className={r.suit_schools == 2 ? "checked" : ""}><label></label></span>
                    <span className={r.suit_schools == 1 ? "checked" : ""}><label></label></span>
                    <span className={r.suit_schools == 0 ? "checked" : ""}><label></label></span>
                </div>} */}
                {isEntitled() && !isLibraryUser() && r.evaluation && r.distributor.value != 'ZZ89' && r.schools_pub_assessment > 0 && <div className="column qualityMetricTextContainer" title={"Schools popularity: " + r.schools_pub_assessment + "/10"}>
                    <div className="qualityMetricText">{r.schools_pub_assessment}/10</div>
                </div>}
            </div>}
            {!dense && <div className="row">
                <div className="gridBadges denseVersion">
                    <GridBadges hit={hit} />
                </div>
            </div>}
            {!dense && isEntitled() && r.distributor.value != 'ZZ89' && <div className={`bookReview${r.schools_only_review && !isLibraryUser() ? ' schoolsOnlyReview' : (r.evaluation ? ' evaluation' : '')}`}>
                {r.schools_only_review && !isLibraryUser() ? r.schools_only_review : (r.evaluation && showeval ? r.evaluation : '')}
            </div>}
            {!dense && !isEntitled() && bibText != '' && r.distributor.value != 'ZZ89' && <div className="bookReview bibText">{bibText}</div>}
            {!r.isbookpack && extraData && extraData[productId] && <div className="listViewStock"><em dangerouslySetInnerHTML={{ __html: getStockMessage(r) }}></em></div>}
        </div>
    </>)
}

const BookPackDetails = ({ hit, dense }) => {
    const r = hit._source;
    const { goToResult } = useContext(SearchContext);

    return (<>
        {!dense && <div className="bookTitle">
            <a className="blue" onClick={(e) => {
                e.preventDefault();
                goToResult(r.id);
            }}>
                <h1 className="pageTitle">{r.title}</h1>
            </a>
        </div>}
        {!dense && <div className="bookAuthor">
            <BookPackOriginatorLink creator={r.origin} />
        </div>}
        {isLibraryUser() && <div className="bookBinding libDetails">{r.id}</div>}
        <div className="bookDetails">
            {isEntitled() && <ul className="bookProperties">
                {isInternal() && !isLibraryUser() && r.id && <li className="ean13">{r.id}</li>}
            </ul>}
            {r.description !== null && <div className="bookReview bibText">{r.description}</div>}
            {!dense && <div className="row"></div>}
            {!dense && <div className="row">
                <div className="gridBadges denseVersion"></div>
            </div>}
        </div>
    </>)
}

const ARBookLevelLink = ({ bookLevel, interestLevel }) => {
    const { doCustomSearch } = useContext(SearchContext);
    let bookLevelDisplay = ""
    if(bookLevel) {
        bookLevelDisplay = bookLevel.toFixed(1).toString()
    }
    return (
        <li >
            <a className="arLevel" title="Click to search for other books at this level" href="#" onClick={e => {
                e.preventDefault();
                doCustomSearch([
                    { "filter": 'filters[acceleratedReader][bookLevel][bookLevelFrom]', value: Math.floor(bookLevel) },
                    { "filter": 'filters[acceleratedReader][bookLevel][bookLevelTo]', value: Math.ceil(bookLevel + 0.1) - 0.1 },
                    { "filter": `filters[acceleratedReader][interestLevel][${interestLevel}][checked]`, "value": "1" }])
            }} ><span className="arLevelLabel">AR Level:&nbsp;</span>{bookLevelDisplay}&nbsp;{interestLevel}&nbsp;</a>
        </li>
    )
}


const BookBandLink = ({ bookBand, bookbandsArray }) => {
    const { doCustomSearch } = useContext(SearchContext);
    return (
        <li >
            {bookbandsArray.length > 1 ?
                <a className="bookBands" title="Click to search for other books at these bands" href="#" onClick={e => {
                    e.preventDefault();
                    doCustomSearch([{ "filter": `filters[bookBand][${bookBand[0]}][checked]`, "value": "1" }, { "filter": `filters[bookBand][${bookBand[1]}][checked]`, "value": "1" }]);
                }}>
                    <span className="bandLabel">Bands:</span><ul>{bookbandsArray}</ul></a>
                :
                <a className="bookBands" title="Click to search for other books at this band" href="#" onClick={e => {
                    e.preventDefault();
                    doCustomSearch([{ "filter": `filters[bookBand][${bookBand}][checked]`, "value": "1" }]);
                }}>
                    <span className="bandLabel">Band:</span><ul>{bookbandsArray}</ul></a>
            }
        </li>
    )
}

const PhonicPhaseLink = ({ phonicPhase }) => {
    const { doCustomSearch } = useContext(SearchContext);
    return (
        <li >
            <a className="phonicPhase" title="Click to search for other books at this phonic phase" href="#" onClick={e => {
                e.preventDefault();
                doCustomSearch([
                    { "filter": `filters[phonic][${phonicPhase}][checked]`, "value": "1" }])
            }} ><span className="phonicPhaseLabel">Phonic phase:&nbsp;</span>{phonicPhase}&nbsp;</a>
        </li>
    )
}

const PriceSection = ({ hit }) => {
    const r = hit._source;
    const productId = r.product_id;

    const { extraData, baskets } = useContext(SearchContext);
    const hasData = extraData && extraData[productId];
    const isPre = !isLibraryUser() && hasData && extraData[productId].offerType == 'pre';

    var offerLink = null;
    if (!isLibraryUser() && hasData) {
        if (extraData[productId].offerPage != null) {
            offerLink = <OfferLink link={"/" + extraData[productId].offerPage} heading="Special offer" name={extraData[productId].offerGroupName} ofid={extraData[productId].offerGroupId} />
        } else if (extraData[productId].offerTiers && extraData[productId].offerTiers.length > 1) {
            offerLink = <BulkDiscountsTable tiers={extraData[productId].offerTiers} />
        } else if (extraData[productId].offerMinQuantity > 1) {
            offerLink = <OfferLink link={null} heading="Class set offer" name={`Order ${extraData[productId].offerMinQuantity} or more copies of this title and get ${extraData[productId].offerDiscount}% off the RRP`} ofid={extraData[productId].offerGroupId} />
        } else if (extraData[productId].offerGroupName) {
            offerLink = <OfferLink link={null} heading="Special offer" name={extraData[productId].offerGroupName} ofid={extraData[productId].offerGroupId} />
        }
    }

    var orderedBeforeTitleText = "This title has been ordered before, or is currently in another basket";

    if (!hasData) {
        // return <div className="column priceSection">
        //     {r.isbookpack != 1 && <div className="pricingDetails" style={{ marginTop: "48px" }}>
        //         RRP&nbsp;{currency(r.rrp)}
        //     </div>}
        // </div>

        return (<div className="column priceSection">
            <span className="searchPrice skeletonItemWithPulse">&nbsp;</span>
            <div className="pricingDetails">
                {isLibraryUser() && !isForSchoolBasket() && <>
                    <span className="skeletonItemWithPulse servicingCost" title="Servicing cost is based on the settings of your active basket and default account code">&nbsp;</span>
                    <br />
                </>}
                {r.isbookpack != 1 && <>
                    RRP&nbsp;{currency(r.rrp)}<span className="savingPercent skeletonItemWithPulse">&nbsp;</span>
                </>}
                {r.isbookpack == 1 && <>
                    <span className="savingPercent skeletonItemWithPulse">&nbsp;</span><span className="savingPercent skeletonItemWithPulse">&nbsp;</span>
                </>}
            </div>
            <div className="gridActions">
                {(!isLibraryUser() || isForSchoolBasket()) &&
                    <span className="searchQuantity skeletonItemWithPulse">&nbsp;</span>
                }
                <AddToBasket key={productId} hit={r} product={productId} />
            </div>
            {offerLink && <span className="offerDetails skeletonItemWithPulse">&nbsp;</span>}
        </div>)
    }

    return (<div className="column priceSection">
        <div className="searchPrice">
            {currency(extraData[productId].price)}
        </div>
        <div className="pricingDetails">
            {isLibraryUser() && !isForSchoolBasket() && <><span title="Servicing cost is based on the settings of your active basket and default account code">Servicing&nbsp;{currency(extraData[productId].servicing)}</span><br /></>}
            RRP&nbsp;{r.isbookpack == 1 ? currency((100 * r.rrp / (100 - extraData[productId].discount))) : currency(r.rrp)}
            {extraData[productId].discount > 0 && <span className="savingPercent">{!isLibraryUser() ? 'Save ' : ''}{extraData[productId].discount}%</span>}
        </div>
        {extraData[productId].orderedBefore == true && <a href={"/isbn?isbn=" + r.id} target="_blank"><i style={{ color: "#ff006d" }} className="fas fa-shopping-basket" title={orderedBeforeTitleText}></i></a>}
        <div className="gridActions">
            {isPre && <a href={"/" + extraData[productId].offerPage} className="button">PRE-ORDER</a>}
            {!isPre && (!isLibraryUser() || isForSchoolBasket()) && (isInternal() || r.hasstock == "1") && <div className="searchQuantity">
                Qty&nbsp;<input className={`productQty${(isInternal() && r.hasstock == "0") ? " productQtyOutOfStock" : ""}`} type="number" max={(isInternal() || r.hasstock == 1) ? "999" : "0"} defaultValue={(isInternal() || r.hasstock == 1) ? "1" : "0"} placeholder="0" />
            </div>}
            <AddToBasket key={productId} hit={r} product={productId} />
        </div>
        {offerLink && <div className="offerDetails">
            {offerLink}
        </div>}
    </div>)
}

const BookPackPriceSection = ({ hit }) => {
    const r = hit._source;
    const productId = r.product_id;

    const { extraData } = useContext(SearchContext);
    const hasData = extraData && extraData[productId];
    const isStandardBookPack = (!r.primary_candidates || r.primary_candidates?.length == 0);
    const isPre = !isLibraryUser() && hasData && extraData[productId].offerType == 'pre';

    var offerLink = null;
    if (!isLibraryUser() && hasData) {
        if (extraData[productId].offerPage != null) {
            offerLink = <OfferLink link={"/" + extraData[productId].offerPage} heading="Special offer" name={extraData[productId].offerGroupName} ofid={extraData[productId].offerGroupId} />
        } else if (extraData[productId].offerTiers && extraData[productId].offerTiers.length > 1) {
            offerLink = <BulkDiscountsTable tiers={extraData[productId].offerTiers} />
        } else if (extraData[productId].offerMinQuantity > 1) {
            offerLink = <OfferLink link={null} heading="Class set offer" name={`Order ${extraData[productId].offerMinQuantity} or more copies of this title and get ${extraData[productId].offerDiscount}% off the RRP`} ofid={extraData[productId].offerGroupId} />
        } else if (extraData[productId].offerGroupName) {
            offerLink = <OfferLink link={null} heading="Special offer" name={extraData[productId].offerGroupName} ofid={extraData[productId].offerGroupId} />
        }
    }

    var orderedBeforeTitleText = "This title has been ordered before, or is currently in another basket";

    if (!hasData) {
        return (<div className="column priceSection">
            <span className="searchPrice skeletonItemWithPulse">&nbsp;</span>
            <div className="pricingDetails">
                {isLibraryUser() && !isForSchoolBasket() && <>
                    <span className="skeletonItemWithPulse servicingCost" title="Servicing cost is based on the settings of your active basket and default account code">&nbsp;</span>
                    <br />
                </>}
                <span className="savingPercent skeletonItemWithPulse">&nbsp;</span><span className="savingPercent skeletonItemWithPulse">&nbsp;</span>
            </div>
            <div className="gridActions">
                {(!isLibraryUser() || isForSchoolBasket()) &&
                    <span className="searchQuantity skeletonItemWithPulse">&nbsp;</span>
                }
                <AddToBasket key={productId} hit={r} product={productId} isBookPack={isStandardBookPack} />
            </div>
            {offerLink && <span className="offerDetails skeletonItemWithPulse">&nbsp;</span>}
        </div>)
    }

    return (<div className="column priceSection">
        <div className="searchPrice">
            {currency(r.min_price)}
        </div>
        <div className="pricingDetails">
            {isLibraryUser() && !isForSchoolBasket() && <><span title="Servicing cost is based on the settings of your active basket and default account code">Servicing&nbsp;{currency(extraData[productId].servicing)}</span><br /></>}
            RRP&nbsp;{currency(r.min_price / (1 - r.discount))}
            {r.discount > 0 && <span className="savingPercent">{!isLibraryUser() ? 'Save ' : ''}{(100 * r.discount)}%</span>}
        </div>
        {extraData[productId].orderedBefore == true && <a href={"/isbn?isbn=" + r.id} target="_blank"><i style={{ color: "#ff006d" }} className="fas fa-shopping-basket" title={orderedBeforeTitleText}></i></a>}
        <div className="gridActions">
            {isPre && <a href={"/" + extraData[productId].offerPage} className="button">PRE-ORDER</a>}
            {isStandardBookPack
                ? <input className="productQty" type="hidden" value={1} />
                : <div className="searchQuantity">
                    Qty&nbsp;<input className="productQty" type="number" max="999" defaultValue={1} placeholder="0" maxLength={3} min={1} />
                  </div>
            }

            <AddToBasket key={productId} hit={r} product={productId} isBookPack={isStandardBookPack} />
        </div>
        {offerLink && <div className="offerDetails">
            {offerLink}
        </div>}
    </div>)
}

const Result = ({ hit, checkbox }) => {
    const idx = hit._index;
    const productId = hit._source.product_id;

    if (idx.includes("dyn_book_packs")) {
        return <><BookPackResult key={productId} hit={hit} checkbox={checkbox} /></>;
    } else { // DOES NOT INCLUDE "dyn_book_packs"
        return <><BookResult key={productId} hit={hit} checkbox={checkbox} /></>;
    }
}

const BookResult = ({ hit, checkbox }) => {
    // const s = {width: 'calc(100%/10)'};
    const r = hit._source;
    // const idx = hit._index;

    const creators = creatorsFromSource(r);
    const url = "/book-page/" + r.id;
    const productId = r.product_id;

    const { goToResult, extraData, updatedGridView } = useContext(SearchContext);
    const hasData = extraData && extraData[productId];

    /* CREATORS INFO ARRAY PARSED*/
    const checkboxLabel = "bookSelected" + productId;

    if (IsBooksForTopic(r)) {
        var imageSrc = "/assets/img/booksForTopics.jpg"
    } else {
        var imageSrc = getImage(r.id)
    }

    const productTitleTooltip = decodeHTML(`${r.title}`);

    return <div data-prid={productId} className={"productContainer searchBox lazy " + (r.isbookpack == 1 ? " bookPackProduct" : "isbook regularBook")}>
        <div className="columns">
            <div className="column columns infoSection">
                {checkbox && <div className="column columns checkMarkSection">
                    <label className="checkMarkContainer" htmlFor={checkboxLabel}>
                        <input id={checkboxLabel} name={checkboxLabel} className="checkMarkInput" type="checkbox" value="true" />
                        <span className="checkMark"></span>
                    </label>
                </div>}
                <div className="third column productImageContainer">
                    <div className="image">
                        <a href={url} onClick={(e) => {
                            e.preventDefault();
                            goToResult(r.id);
                        }}>
                            {!updatedGridView && <div className="gridHover">
                                <div className="bookTitle">
                                    <div className="gridProductTitle">
                                        {!r.isbookpack ? <>
                                            {decodeHTML(`${r.title}${r.subtitle ? `&#58;&nbsp;${r.subtitle}` : ''}`)}
                                        </> : <>
                                            {r.title}
                                            {r.subtitle &&
                                                <>&#58;&nbsp;{r.subtitle}</>
                                            }
                                        </>}
                                    </div>
                                    <div className="bookAuthor">
                                        <Creators source={hit._source}/>
                                    </div>
                                </div>
                            </div>}

                            {!r.isbookpack ? (hasData && extraData[productId].offerMinQuantity > 1 ?
                                <ClassSetOverlay source={r} productImgSrc={imageSrc} /> :
                                <img key={r.id} className="productImg lazy bookImg testing" src={imageSrc} title={productTitleTooltip} alt={productTitleTooltip} onError={(e) => { handleImageError(e.target) }} />
                            ) : <BookPackCollage source={r} />}
                        </a>
                        {/* <nav>
                            <Link to={url}></Link>
                        </nav> */}
                    </div>

                    <div className="gridBadges">
                        <GridBadges hit={hit} />
                    </div>
                    <Badges hit={hit} />
                </div>
                <div className="twoThirds defaultDetails column">
                    <BookDetails hit={hit} creators={creators} dense={false} />
                </div>
                <div className="denseColumn twoThirds column bookInfoColumn">
                    <BookDetails hit={hit} creators={creators} dense={true} />
                </div>
            </div>
            <PriceSection hit={hit} />
        </div>
    </div>
}

const BookPackResult = ({ hit, checkbox }) => {
    const r = hit._source;
    const idx = hit._index;

    const url = "/book-page/" + r.id;
    const productId = r.product_id;

    const { goToResult, updatedGridView } = useContext(SearchContext);

    /* CREATORS INFO ARRAY PARSED*/
    const checkboxLabel = "bookSelected" + productId;

    return <div data-prid={productId} className="productContainer searchBox lazy bookPackProduct">
        <div className="columns">
            <div className="column columns infoSection">
                {checkbox && <div className="column columns checkMarkSection">
                    <label className="checkMarkContainer" htmlFor={checkboxLabel}>
                        <input id={checkboxLabel} name={checkboxLabel} className="checkMarkInput" type="checkbox" value="true" />
                        <span className="checkMark"></span>
                    </label>
                </div>}
                <div className="third column productImageContainer">
                    <div className="image">
                        <a href={url} onClick={(e) => {
                            e.preventDefault();
                            goToResult(r.id);
                        }}>
                            {!updatedGridView && <div className="gridHover">
                                <div className="bookTitle">
                                    <div className="gridProductTitle">{r.title}</div>
                                    <div className="bookAuthor">
                                        <BookPackOriginatorLink creator={r.origin} />
                                    </div>
                                </div>
                            </div>}
                            <BookPackCollage source={r} />
                        </a>
                    </div>
                    <div className="gridBadges"></div>
                </div>
                <div className="twoThirds defaultDetails column">
                    <BookPackDetails hit={hit} dense={false} />
                </div>
                <div className="denseColumn twoThirds column bookInfoColumn">
                    <BookPackDetails hit={hit} dense={true} />
                </div>
            </div>
            <BookPackPriceSection hit={hit} />
        </div>
    </div>
}

const SearchHeadBar = ({ total }) => {
    const { wishlist, sortHTML } = useContext(SearchContext);
    return (
        <div className={"searchHeadBar sortItemsParent " + (wishlist ? "checkmarkAll" : "")}>
            {wishlist && <label className="checkMarkContainer" htmlFor="allBooksSelected">
                <input id="allBooksSelected" name="allBooksSelected" className="checkMarkInput" type="checkbox" value="true" />
                <span className="checkMark"></span>
            </label>}
            <div className="sortContainer">
                <div className="bppText">Sort by</div>
                <ol className="sortItemList" dangerouslySetInnerHTML={{__html: sortHTML}}></ol>
                <i title="Add sort item" className="fal fa-plus addSortItem"></i>
            </div>
            <Pagination total={total} />

        </div>
    )
}

const Pagination = ({ total }) => {
    const { limit, page, displayFrom, setLimit, changePage, applyFilters, wishlist } = useContext(SearchContext);
    var pages = Math.ceil(total / limit);
    if (displayFrom > 1) {
        pages = Math.floor((total - displayFrom) / limit);
    }
    var showpages = [];
    for (var i = page - 2; i <= page + 2; i++) {
        showpages.push(i);
    }
    return (
        <div className="pagination">
            <div className="info">
                <div className="bppText">&nbsp;Results per page</div>
                <div className="selectWrapper">
                    <select className="limit" name="limit" value={limit} onChange={e => setLimit(Number(e.target.value))}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div className="bppText">&nbsp;display from</div>
                <input className="displayFrom" type="number" defaultValue="1" name="displayFrom" min="1" max="10000" />
                <i title="Update list" style={{ marginLeft: 0, marginRight: "1rem" }} className="fal fa-redo updateList" onClick={applyFilters}></i>

                {!wishlist && <span className="saveSearch" onClick={() => { openModal("saveSearchModal") }}><i className="fas fa-save" title="Save this search"></i> Save this search</span>}
            </div>
            <div className="items">
                <div id="pageNav">
                    {page > 1 && <span onClick={() => changePage(1)} className="actionButton pageButton  far fa-chevron-double-left"></span>}
                    {page > 1 && <span onClick={() => changePage(page - 1)} className="actionButton far fa-chevron-left pageButton "></span>}
                    {showpages.map((p, i) => {
                        var classes = "pageButton pageNumber";
                        if (p == page) {
                            classes += " current selected";
                        }
                        return (<span key={i}>
                            {p > 0 && p <= pages && <span onClick={() => changePage(p)} className={classes}>{p}</span>}
                        </span>)
                    })}
                    {page < pages && <span onClick={() => changePage(page + 1)} className="actionButton far fa-chevron-right pageButton "></span>}
                    {page < pages && <span onClick={() => changePage(pages)} className="actionButton pageButton  far fa-chevron-double-right"></span>}
                </div>
            </div>
        </div>
    )
}

const ISBNModal = () => {
    const { ids } = useContext(SearchContext);
    const body = ids ? <textarea style={{ width: "600px", height: "200px", resize: "vertical" }}>{ids.join(",")}</textarea> : <LoadingSpinner size="48px" />
    const buttons = [
        {
            id: "1",
            text: "OK",
            classes: "btn-primary",
            close: true,
        }
    ];

    return <Modal id="isbncsv" buttons={buttons} body={body} heading="ISBN CSV" />
}

const buildBaskets = baskets => {
    let basketsArray = [];

    if (baskets) {
        for (let b in baskets) {
            if (baskets[b].type != "Furniture" && baskets[b].type != "wishlist") {
                basketsArray.push(baskets[b]);
            }
        }
    }

    return basketsArray;
}

// const buildExtraDataArray = extraData => {
//     let extraDataArray = [];

//     if (extraData) {
//         for (key => val in extraData) {
//                 extraDataArray.push(extraData[key] extraData[val]);
//             }
//         }
//     return extraDataArray;
// }

// const ISBNModal = () => {
//     const {ibns} = useContext(SearchContext);
//     const body = ibns ? <textarea style={{width:"600px",height:"200px",resize:"vertical"}}>{ibns.join(",")}</textarea> : <LoadingSpinner size="48px" />
//     const buttons = [
//         {
//             id: "1",
//             text: "OK",
//             classes: "btn-primary",
//             close: true,
//         }
//     ];

//     return <Modal id="isbncsv" buttons={buttons} body={body} heading="ISBN CSV" />
// }
const AddItemsToBasketModal = () => {
    const { ids, baskets, activeBasketId, limit, page, bookshelves } = useContext(SearchContext)

    const basketsArray = buildBaskets(baskets)

    const heading = ids ? "Add items to basket" : "";

    const body = ids ? (<>
        <form className='addPageToBasketForm'>
            <input type="radio" id="addPage" name="addPageToBasketRadio" value='addPage' defaultChecked className="addPageToBasketRadio" />
            <label htmlFor="addPage">Add this page only</label><br />

            <input type="radio" id="addSearch" name="addPageToBasketRadio" value='addSearch' className="addPageToBasketRadio" />
            {ids.length <= 200 ?
                <><label htmlFor="addSearch" >Add this search ({ids.length} items)</label><br /></>
                :
                <><label htmlFor="addSearch" >Add this search (top 200  results)</label><br /></>
            }
            <input className="addPageToBasketCheckbox" type="checkbox" name="exclTitles" id="exclTitles" />
            <label htmlFor="exclTitles"> Don't add titles already supplied or in any basket</label>
            <br />
            <label htmlFor="basketSelector">Basket:&nbsp;</label>
            <select className="addPageToBasketSelector" id="basketSelector">
                {basketsArray.map(bs => <option value={bs.id} selected={bs.id == activeBasketId}>{bs.name}</option>)}
                {basketsArray.length === 0 && <option value="new">Basket</option>}
            </select>
            <p className="reponseMessage"></p>
        </form></>) :
        <LoadingSpinner size="48px" />

    const buttons = [
        {
            id: "2",
            text: "CANCEL",
            classes: "btn-light addPageToBasketForm",
            close: true,
            onClick: (e) => {
                e.preventDefault();
                return false;
            }
        }
    ]

    if (ids !== null) {
        buttons.push({
            id: "1",
            type: "submit",
            text: "CONFIRM",
            classes: "btn-primary addPageToBasketForm",
            close: false,
            onClick: (e) => {
                e.preventDefault();

                const offset = Number((page - 1) * limit)
                const pageResults = ids.slice(offset, limit + offset)
                const top200 = ids.length > 200 ? ids.slice(0, 200) : ids

                const itemsToAdd = document.getElementById('addPage').checked ? pageResults : top200
                const basketId = $('#basketSelector :selected').val()
                const exclTitles = document.getElementById('exclTitles').checked
                $('#addItemsToBasketModal .modal-body .reponseMessage').fadeIn().text("Adding items, please wait...");
                $('#addItemsToBasketModal .btn-primary.addPageToBasketForm').addClass("disabled");
                fetchJson('/basket/addArray/' + basketId + '/ean', {
                    items: itemsToAdd,
                    exclTitles: exclTitles
                }).then(result => {
                    if (result.notAdded) {
                        const notifyErrorMessage = [];
                        if (result.notAdded.unavailable) {
                            notifyErrorMessage.push(<h5 style={{ textAlign: "left" }}>Unavailable</h5>);
                            result.notAdded.unavailable.map(u => notifyErrorMessage.push(<li style={{ textAlign: "left" }}>{u}</li>));
                        }
                        if (result.notAdded.supplied) {
                            notifyErrorMessage.push(<h5 style={{ textAlign: "left" }}>Supplied</h5>);
                            result.notAdded.supplied.map(u => notifyErrorMessage.push(<li style={{ textAlign: "left" }}>{u}</li>));
                        }
                        if (result.notAdded.basketed) {
                            notifyErrorMessage.push(<h5 style={{ textAlign: "left" }}>In another basket</h5>);
                            result.notAdded.basketed.map(u => notifyErrorMessage.push(<li style={{ textAlign: "left" }}>{u}</li>));
                        }
                        notifyError("Unable to add the following titles", notifyErrorMessage).then(() => {
                            closeModal("addItemsToBasketModal");
                            $('#addItemsToBasketModal .modal-body .reponseMessage').fadeOut().text("");
                            $('#addItemsToBasketModal .btn-primary.addPageToBasketForm').removeClass("disabled");
                        });
                    } else {
                        buildBaskets(baskets)
                        closeModal("addItemsToBasketModal");
                        $('#addItemsToBasketModal .modal-body .reponseMessage').fadeOut().text("");
                        $('#addItemsToBasketModal .btn-primary.addPageToBasketForm').removeClass("disabled");
                    }

                    loadBasketDraw();
                });

                return false;
            }
        });
    }

    return <Modal id="addItemsToBasketModal" buttons={buttons} body={body} heading={heading} />
}

const SearchButtonsBar = () => {
    const { bookshelves, ids, getIds, wishlist, baskets, addPageToBookshelf, searchString, bookshelfToAddTo, setBookshelfToAddTo } = useContext(SearchContext);

    const [ load, setLoad ] = useState(false);

    if (wishlist && baskets && baskets[wishlist]) {
        return <div className="basketSummary">
            <p className="basketSummaryItems">
                <span className="basketSummaryLabel">Total items:</span>
                <span className="basketSummaryValue">&nbsp;{baskets[wishlist].quantity} item{baskets[wishlist].quantity !== 1 ? "s" : ""}</span>
            </p>
            <p className="basketSummaryPrice">
                <span className="basketSummaryLabel">Sub total:</span>
                <span className="basketSummaryValue">&nbsp;{currency(baskets[wishlist].total)}</span>
            </p>
        </div>
    }

    // if (!sidebarLoaded) {
    //     return null;
    // }

    // the dropdown falls back to the first bookshelf until the provider has picked one
    const selectedBookshelfId = (bookshelves && bookshelves.length > 0)
        ? (bookshelfToAddTo || String(bookshelves[0].bksId))
        : "new";
    const selectedBookshelf = bookshelves ? bookshelves.find(shelf => String(shelf.bksId) === selectedBookshelfId) : null;
    const selectedBookshelfName = selectedBookshelf ? selectedBookshelf.bksName : "New bookshelf";

    return (
        <div className="searchButtonsBar">
            {/* only shown on mobile, where the filter sidebar is off canvas */}
            <label className="hamburger button" htmlFor="hamburgerMenuFilterBar">
                <div className="hamburgerBox">
                    <span className="hamburgerInner"></span>
                </div>
                <div className="hamburgerText">Filter</div>
            </label>
            {isEntitled() && <button onClick={() => {
                if (ids === null) {
                    getIds();
                }
                openModal("isbncsv");
            }} className="button" type="button" id="isbnCsvGen">
                <span>View ISBN CSV</span>
            </button>}
            {(!isLibraryUser() || isForSchoolBasket()) && <button onClick={() => {
                if (ids === null) {
                    getIds();
                }
                openModal("addItemsToBasketModal");
            }} className="button" type="button" id="addPageToBasketGen" title="Note: furniture items will not be added automatically">
                <span>Add items to basket</span>
            </button>}
            {isInternal() && <button onClick={() => {
                var formData = new FormData();
                formData.append("urlAppliedFiltersJson", searchString);
                setLoad(true);
                axios.post("/search/bibdata", formData, {responseType: 'blob'}).then(r => {
                    setLoad(false);
                    const bloburl = URL.createObjectURL(r.data);
                    const link = document.createElement("a");
                    link.href = bloburl;
                    link.setAttribute('download', 'results.mrc');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(bloburl);
                }).finally(() => {
                    setLoad(false);
                });
            }} className="button" type="button">
                <span>Download MARC</span>
            </button>}

            {load && <LoadingSpinner overlay={true} />}
            {bookshelves && bookshelves.length > 0 && <div className="addToBasketContainer">
                <div className="addButtonContainer bookshelf">
                    <div title="Click to add all items on the current page to the selected bookshelf (except furniture)" className="addToBasket basketButton bookshelfButton" id="addPageToBookshelf" onClick={addPageToBookshelf}><p className="wishlistText">ADD CURRENT PAGE TO {selectedBookshelfName}</p></div>
                    <div className="addToBasketSelectWrapper">
                        <select value={selectedBookshelfId} onChange={e => setBookshelfToAddTo(e.target.value)} className="addToBasketSelect" dir="rtl" name="bookshelfToAddTo" id="addPageToBookshelfSelect">
                            {bookshelves.map(shelf => <option key={shelf.bksId} value={shelf.bksId}>{shelf.bksName}</option>)}
                            <option value="new">New bookshelf</option>
                        </select>
                    </div>
                </div>
            </div>}
        </div>
    )
}

const ExpertSelections = () => {
    const { page } = useContext(SearchContext); //const page = 2;

    return (
        (page % 2 == 0) && !isLibraryUser() && <div id="schoolsSearchListBanners" className="linkSection resultsListBanners">
            <div id="classSetsBanner" className="columns wrap bottomSection">
                <div className="half column">
                    <div className="linkSectionBg3 linkSectionSizing">
                        <h3><strong><a href="https://peters.co.uk/expert-selections" style={{ color: "white" }}>Expert selections</a></strong></h3>
                        <p>Need some help finding the right books? Our team of librarians and curriculum specialists can put together a bespoke selection for you. Email <a href="mailto:hello@peters.co.uk" style={{ color: "white" }}>hello@peters.co.uk</a> and one of us will be in touch.</p>
                    </div>
                </div>
                <div className="half column linkSectionSizing">
                    <a id="classSetsBannerImage" href="https://peters.co.uk/expert-selections"></a>
                </div>
            </div>
        </div>
    )
}

const ViewControls = ({ avgrrp, total }) => {
    const { limit, offset, updatedGridView } = useContext(SearchContext);
    const searchViewType = getSearchViewType(updatedGridView);
    let denseViewClasses = "viewTypeSelector";
    let listViewClasses = "viewTypeSelector";
    let gridViewClasses = "viewTypeSelector";

    if(searchViewType == "dense") denseViewClasses += " selectedSeachView";
    else if(searchViewType == "list") listViewClasses += " selectedSeachView";
    else if(searchViewType == "grid") gridViewClasses += " selectedSeachView";

    const toggleFilterSidebar = (e) => {
        const searchListWidthWithSidebar = $('#searchForm').width() - 215;
        if($(e.target).hasClass('filterSidebarOpen')) {
            $('#sidebarShowHideText').text("Show");
            $(e.target).removeClass('filterSidebarOpen');
            $('#searchList').stop().animate({width: '100%'}, 500, "linear");
        } else {
            $('#sidebarShowHideText').text("Hide");
            $(e.target).addClass('filterSidebarOpen');
            $('#searchList').stop().animate({width: searchListWidthWithSidebar + "px"}, 500, "linear", function() {$("#searchList").css({ width: "calc(100% - 215px)" })});
        }
    }

    return (<div className="viewButtons">
        <h2 className="viewButtonsTitle toggleFilterSidebar filterSidebarOpen" onClick={toggleFilterSidebar}><i id="toggleFilterSidebarIcon" className="fas fa-chevron-right"></i><span id="sidebarShowHideText">Hide</span> sidebar</h2>
        <h2 className="viewButtonsTitle">{total >= 10000 ? "10,000+" : total.toLocaleString()} items, displaying items {offset + 1} to {Math.min(Number(offset + limit), total)}.{isInternal() && <> Average RRP: {currency(avgrrp)}</>}</h2>
        <p className="viewOptions">
            View:&nbsp;
            <span id="denseViewSwitch" title="Compact view" className={denseViewClasses} type="dense"><i className="fas fa-line-columns"></i></span>&nbsp;
            <span id="listViewSwitch" title="Detailed view" className={listViewClasses} type="list"><i className="fas fa-th-list"></i></span>&nbsp;
            <span id="gridViewSwitch" title="Gallery view" className={gridViewClasses} type="grid"><i className="fas fa-th-large"></i></span>
        </p>
    </div>)
}

const Results = ({ results, didyoumean, total, undo, redo, undoStack, redoStack }) => {
    const { wishlist, bookshelves, filterTags, booleanTags, missingIsbns } = useContext(SearchContext);

    return (
        <div id="search" className="search">
            {(total > 0) && <div className="booleanFilterList">
                {!!booleanTags && <div id="structuredBooleanFilters" className="open" dangerouslySetInnerHTML={{__html: booleanTags}}>
                </div>}
            </div>}
            <div className="viewButtons">
                <p className="viewOptions">
                    {<span id="appliedFilters" dangerouslySetInnerHTML={{__html: filterTags}}></span>}
                </p>
            </div>
            {!!missingIsbns && isEntitled() && <div className="searchPageContentBox viewButtons open">
                <p className="viewOptions"><strong>ISBNs from your search list not found</strong></p>
                <p className="viewOptions">
                    {Object.values(missingIsbns).map(isbn => <li className="filterTag item">{isbn}</li>)}
                </p>
            </div>}
            {(total > 0)&& <SearchHeadBar total={total} />}
            {(total > 0)&& <SearchButtonsBar key={bookshelves ? bookshelves.length : 0} />}
            {total === 0 && <div className="tooFewFiltersWarning">
                {didyoumean && didyoumean[0] && <Didyoumean didyoumean={didyoumean} />}
                {(!didyoumean || didyoumean?.length == 0) && <>
                    <h3>No results</h3>
                    <p>To help us find the best books for you, please amend your search criteria using the filters on the lefthand side.</p>
                </>}
            </div>}
            <div className="searchItems">
                {total > 0 && total && results.hits.hits && results.hits.hits.map(r => <Result key={r._source.product_id} hit={r} checkbox={wishlist ? true : false} />)}
            </div>
            {(total > 0)&& <SearchHeadBar total={total} />}
            {(total > 0)&& <ExpertSelections />}
        </div>
    )
}

const Suggestions = ({ suggestions, results }) => {
    const [hide, setHide] = useState(false);

    const { doCustomSearch, sidebarLoaded, keywordsData, bicData, themaData, deweyReady } = useContext(SearchContext);

    if (!results.aggregations || !deweyReady || (!suggestions && !results.hits.hits)) {
        return null;
    }

    if (isLibraryUser() && (!themaData.loaded || !bicData.loaded)) {
        return null;
    }

    const style = { textAlign: "left", fontSize: "12px", paddingBottom: "0.5rem" };

    return (<div className="filtersGroup">
        <div className="filterSection titleAdvanced" onClick={() => setHide(!hide)}>
            <h5><i className="far fa-wand-magic"></i> Suggestions</h5>
            <span className='toggleDisplay'>{!hide ? "hide" : "show"}</span>
        </div>
        {!hide && <ul className="filterSection" style={{ padding: "0" }}>
            {isLibraryUser() && !bicData.error && results.aggregations.bic.buckets.filter(bic => bic.key != "").slice(0, 2).map(bic => {
                return <li key={bic.key}><a style={style} href="#" onClick={e => {
                    e.preventDefault();
                    doCustomSearch([{ filter: "filters[bicCodes][value]", value: bic.key }]);
                }}>{bicData[bic.key]} (BIC)</a></li>
            })}
            {results.aggregations.keywords && results.aggregations.keywords.buckets.map(k => {
                if (keywordsData[k.key]) {
                    return <li key={k.key}><a style={style} href="#" onClick={e => {
                        e.preventDefault();
                        doCustomSearch([{ filter: "filters[keywords][selectedKeyword]", value: k.key }]);
                    }}>{keywordsData[k.key]} (keyword)</a></li>
                }
            })}
            {sidebarLoaded && results.aggregations.dewey.buckets && results.aggregations.dewey.buckets.slice(0, 1).map((d, i) => {
                const inputs = document.querySelectorAll(".deweyTree input");
                if (!inputs) {
                    return;
                }
                var deweys = Array.from(inputs).filter(e => Number(e.dataset.start) <= Number(d.key) && Number(e.dataset.end) >= Number(d.key));
                if (!deweys || !deweys.length) {
                    return;
                }
                const innermost = deweys[deweys.length - 1];
                return <li key={i}><a style={style} href="#" onClick={e => {
                    e.preventDefault();
                    doCustomSearch([{ filter: "filters[dewey][dewey][from]", value: innermost.dataset.start }, { filter: "filters[dewey][dewey][to]", value: innermost.dataset.end }, { filter: "filters[dewey][dewey][title]", value: innermost.dataset.title }]);
                }}>{innermost.dataset.title} (Dewey)</a></li>
            })}
            {suggestions && suggestions.map((s, i) => {
                if (s.type == "list") {
                    return <li key={i}><a style={style} href="#" onClick={e => {
                        e.preventDefault();
                        doCustomSearch([{ filter: "searchListId", value: s.id }])
                    }}>{s.title} ({s.type})</a></li>
                } else if (s.type == "page") {
                    return <li key={i}><a style={style} href={s.url} title={s.title}>{s.title} ({s.type})</a></li>
                }
            })}
            {isLibraryUser() && !themaData.error && results?.aggregations?.thema?.buckets.filter(t => t.key != "").map(thema => {
                if (!themaData[thema.key]) {
                    return null;
                }
                return <li key={thema.key}><a style={style} href="#" onClick={e => {
                    e.preventDefault();
                    doCustomSearch([{ filter: "filters[thema][code]", value: thema.key }]);
                }}>{themaData[thema.key].description} (Thema)</a></li>
            })}
        </ul>}
    </div>)
}

const Didyoumean = ({ didyoumean }) => {
    const { doCustomSearch } = useContext(SearchContext);

    return (<>
        <h3>No results - did you mean <a href="#" onClick={e => {e.preventDefault();doCustomSearch([{ filter: "searchTerm", value: didyoumean[0].text }])}} dangerouslySetInnerHTML={{__html: didyoumean[0].highlighted }} />?</h3>
        <p>To help us find the best books for you, please amend your search criteria using the filters on the lefthand side.</p>
    </>)
}

const FurnitureResults = ({ furniture, furnitureCount }) => {
    const [hide, setHide] = useState(Cookies.get("hideFurnitureResults") == 1 ? true : false);

    return (
        <>
            <h4 className="petersBlue" onClick={() => {
                setHide(!hide);
                Cookies.set("hideFurnitureResults", !hide ? 1 : 0, { sameSite: "Strict" });
            }} style={{ marginTop: "0", cursor: "pointer" }}>
                <i className={hide ? "fa fa-caret-right" : "fa fa-caret-down"}></i> Furniture results ({furnitureCount})
            </h4>
            {!hide && <div className="searchItems" dangerouslySetInnerHTML={{ __html: furniture }}></div>}
        </>
    )
}

const FurnitureSearch = ({ results, slClasses, suggestions, didyoumean, sidebarLoaded, viewingResult, furniture, furnitureCount, total, undo, redo, undoStack, redoStack }) => {
    return <div className="search container">
            <div className="columns">
                <input id="hamburgerMenuFilterBar" className="hamburgerInput" type="checkbox" />
                <div className="filterBarOverlay"></div>
                <div id="filterSidebarContainer">
                    <div id="filterSidebar" className="column mobileSidebar">
                        <label className="hamburger" htmlFor="hamburgerMenuFilterBar">
                            <div className="hamburgerBox">
                                <span className="hamburgerInner"></span>
                            </div>
                            <div className="hamburgerText">Filter</div>
                        </label>
                        <div className="filterBar">
                            {isEntitled() && !document.getElementById("awardsTimeline") && <Suggestions suggestions={suggestions} results={results} />}
                            {!sidebarLoaded && <span>Loading...</span>}
                            <div id="searchFilters" style={{ display: viewingResult ? "none" : "block" }}></div>
                        </div>
                    </div>
                </div>
                <div id="searchList" className={slClasses}>
                    {furniture && <FurnitureResults furniture={furniture} furnitureCount={furnitureCount} />}
                    <Results didyoumean={didyoumean} results={results} total={total} undo={undo} redo={redo} undoStack={undoStack} redoStack={redoStack} />
                </div>
            </div>
        </div>
}

const BookWishlistResults = ({ results, slClasses, total, undo, redo, undoStack, redoStack }) => {
    const { wishlist } = useContext(SearchContext);

    useEffect(() => {
        // if we are not 'actually' on the wishlist page (because we came back from a different search) we will just reload the page entirely so that the wishlist functions appear properly
        if (!wishlist) {
            window.location.reload();
            return;
        }
    }, []);

    return <div className="search container">
            <div className="columns">
                <input id="hamburgerMenuFilterBar" className="hamburgerInput" type="checkbox" />
                <div className="filterBarOverlay"></div>
                <div id="searchList" className={slClasses}>
                    <Results results={results} total={total} undo={undo} redo={redo} undoStack={undoStack} redoStack={redoStack} />
                </div>
            </div>
        </div>
}

const QuickSearch = () => {
    const navigate = useNavigate();
    const [ searchParams, setSearchParams ] = useSearchParams();

    const [results, _setResults] = useState([]);
    const [extraData, _setExtraData] = useState(null);
    const [limit, setLimit] = useState(Cookies.get('limitCountNew') ? Number(Cookies.get('limitCountNew')) : 20);
    const [page, _setPage] = useState(1);
    const [offset, setOffset] = useState(0);
    const [total, setTotal] = useState(null);
    const [displayFrom, setDisplayFrom] = useState(1);
    const [baskets, setBaskets] = useState(null);
    const [activeBasketId, _setActiveBasketId] = useState(0);
    const [awardsData, setAwardsData] = useState([]);
    const [bestsellersData, setBestsellersData] = useState([]);
    const [bookshelves, _setBookshelves] = useState(null);
    const [sharedBookshelves, setSharedBookshelves] = useState(null);
    const [viewingResult, _setViewingResult] = useState(null);
    const [viewPrevious, _setViewPrevious] = useState(false);
    const [undoStack, _setUndoStack] = useState([]);
    const [redoStack, setRedoStack] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [didyoumean, setDidyoumean] = useState([]);
    const [sidebarLoaded, setSidebarLoaded] = useState(false);
    const [resultsLoaded, setResultsLoaded] = useState(false);
    const [sidebarHTML, setSidebarHTML] = useState("");
    const [sortHTML, setSortHTML] = useState("");
    const [ids, setIds] = useState(null);
    const [missingIsbns, setMissingIsbns] = useState(null);
    const [furniture, setFurniture] = useState(null);
    const [furnitureCount, setFurnitureCount] = useState(0);
    const [booleanFilters, setBooleanFilters] = useState("");
    const [searchString, setSearchString] = useState("");
    const [deweyReady, setDeweyReady] = useState(false);
    const [keywordsData, setKeywordsData] = useState({});
    const [internalKeywordsData, setInternalKeywordsData] = useState({});
    const [bicData, setBicData] = useState({ loaded: false, error: false });
    const [themaData, setThemaData] = useState({ loaded: false, error: false });
    const [basketSelect, setBasketSelect] = useState({});
    const [bookshelfSelect, setBookshelfSelect] = useState({});
    const [bookshelfToAddTo, setBookshelfToAddTo] = useState("");
    // const [inBookshelfData, setInBookshelfData] = useState({});
    const [filterTags, setFilterTags] = useState("");
    const [booleanTags, setBooleanTags] = useState("");
    const [updatedGridView, setUpdatedGridView] = useState(false);

    // each product's highest bestseller position, so badges don't have to search the whole list on every render
    const bestsellersByProduct = React.useMemo(() => {
        const byProduct = {};
        bestsellersData.forEach(bs => {
            if (!byProduct[bs.product] || Number(bs.rank) < Number(byProduct[bs.product].rank)) {
                byProduct[bs.product] = bs;
            }
        });
        return byProduct;
    }, [bestsellersData]);

    useEffect(() => {
        fetchJson("/product/checkFeatureFlag/updated_grid_view").then(r => {
            setUpdatedGridView(r);
        });
    }, []);

    const viewPreviousRef = React.useRef(viewPrevious);
    const setViewPrevious = data => {
        viewPreviousRef.current = data;
        _setViewPrevious(data);
    }

    const resultsRef = React.useRef(results);
    const setResults = data => {
        data?.hits?.hits?.forEach(hit => {
            const s = hit._source;
            if (s.publish_date === '0000-00-00' || s.publish_date === '0001-01-01T00:00:00Z') s.publish_date = null;
        });
        resultsRef.current = data;
        _setResults(data);
    }

    const bookshelvesRef = React.useRef(bookshelves);
    const setBookshelves = data => {
        bookshelvesRef.current = data;
        _setBookshelves(data);
    }

    const activeBasketIdRef = React.useRef(activeBasketId);
    const setActiveBasketId = data => {
        activeBasketIdRef.current = data;
        _setActiveBasketId(data);
    }

    const pageRef = React.useRef(page);
    const setPage = data => {
        pageRef.current = data;
        _setPage(data);
    }

    const viewingResultRef = React.useRef(viewingResult);
    const setViewingResult = data => {
        viewingResultRef.current = data;
        _setViewingResult(data);
    }

    const undoStackRef = React.useRef(undoStack);
    const setUndoStack = data => {
        undoStackRef.current = data;
        _setUndoStack(data);
    };

    const extraDataRef = React.useRef(extraData);
    const setExtraData = data => {
        extraDataRef.current = data;
        _setExtraData(data);
    };

    const isInitialMount = useRef(true);
    const goToNextResultRef = useRef(null);
    const filterTagClickRef = useRef(null);
    const nextPageOrderingGridRef = useRef(null); // basket id to open the first result's ordering grid in once the next page loads

    const wishlist = document.querySelector("[name='wishlist']") ? document.querySelector("[name='wishlist']").value : null;
    const path = window.location.pathname.split("/");
    var bookpageIsbn = "";
    const at = (path[1] == 'awards-timeline');
    const bookpage = (path[1] == 'book-page');
    if (bookpage) {
        bookpageIsbn = path[2];
    }

    const changePage = p => {
        setPage(p);
        var formData = new FormData();
        formData.append("urlAppliedFiltersJson", searchString);
        formData.set("page", p);
        if (bookpage) {
            doSearch(formData, false);
        } else {
            goToSearch(formData);
        }
        $('.filterModal.open .closeModal').trigger('click');
        $('#hamburgerMenuFilterBar').prop('checked', false);
    }

    const applyFilters = () => {
        setIds(null);
        doFilterSearch();
        $('.filterModal.open .closeModal').trigger('click');
        $('#hamburgerMenuFilterBar').prop('checked', false);
    }

    const removeFilter = (el) => {
        var $filterTag = $(el);
        // var filterTagCount = $('#appliedFilters li.filterTag').length;
        // filterTagCount += $('#structuredBooleanFilters li.filterTag').length;

        var searchCount = Number($('#search').attr('count'));
        // if(filterTagCount != 1 || searchCount == 0){
        var filterItem = $filterTag.attr('filter');
        if ($filterTag[0].hasAttribute('otherformatfilter')) {
            filterItem = 'otherFormat';
        }
        var filterCat = $filterTag.attr('parent');
        if (filterCat == "searchTerm") {
            $('#headerSearch').val('');
            $('.selectSearchDropdown').val('');
            filterItem = "search";
        }

        if ((filterCat == "languages" && filterItem != "dualLanguage" && filterItem != "foreignLanguage")) {
            $('body').find('[category="' + filterCat + '"]').find('select').remove()
        } else {
            var $input;
            if (filterCat == 'phonic') {
                $input = $('body').find('[category="' + filterCat + '"]').find('[item="phonic' + filterItem + '"]');
            } else if (filterCat == 'keywords') {
                $input = $('body').find('[category="' + filterCat + '"]').find('#keywordSelect');
            } else {
                $input = $('body').find('[category="' + filterCat + '"]').find('[item="' + filterItem + '"]');
            }

            if (!$input.length && filterCat == "subject" && (filterItem == "35" || filterItem == "36")) {
                $input = $('body').find('[item="' + filterItem + '"][titlefiltercheckbox]');
            }

            if (!$input.length && filterCat == "subject") {
                $('body').find('[category="' + filterCat + '"]').find('select').remove();
            } else {
                $input.remove();
            }
        }
        if (filterCat == "themaQualifier") {
            $('#themaQualifier').val("");
            if (/\d/.test($('#themaCode').val().charAt(0))) {
                $('#themaCode').val("");
            }
        } else if (filterCat == "thema") {
            $('#themaCode').val("");
        }

        $filterTag.remove();
        var formData = new FormData(document.getElementById("searchForm"));
        loadFilterSidebar(formData);
    }

    const getAggregation = (agg, formData, $el, prefix = "") => {
        fetchJson("/search/aggregation/" + agg, formData).then(r => {
            $el.parent().find("label").each(function () {
                if ($(this).hasClass("checkMarkContainer")) {
                    return;
                }
                if ($(this).find("span").first().find("span").length) {
                    return;
                }
                const b = r.aggregations.aggregation.buckets.find(bucket => $(this).attr("for") == (prefix + bucket.key));
                var text = $(this).find("span").text();
                var count = '<span style="color:red;">0</span>';
                if (b) {
                    count = '<span style="color:green;">' + b.doc_count + '</span>';
                }
                $(this).find("span")[0].innerHTML = text + " " + count;
            });
            // r.aggregations.aggregation.buckets.forEach(b => {
            //     var $label = $el.parent().find("label[for='"+b.key+"']");
            //     if ($label.length) {
            //         var text = $label.find("span").text();
            //         $label.find("span")[0].innerHTML = text + " ("+b.doc_count+")";
            //     }
            // });
        });
    }

    const loadFilterSidebar = formData => {
        if (wishlist) {
            setSidebarLoaded(true);
            return;
        }
        setSidebarLoaded(false);
        formData.append("searchFiltersJson", document.querySelector("[name='searchFiltersJson']").value);
        const path = window.location.pathname.split("/");

        var url = "/search/filterSidebar";
        if (path[1] == 'awards-timeline') {
            url = "/award/timeline";
            const ag = document.querySelector("[name='awardGroup']");
            if (ag) {
                formData.append("awardGroup", ag.value);
            }
        }

        fetch(url, {
            body: formData,
            method: "POST"
        }).then(r => r.text()).then(r => {
            setSidebarLoaded(true);
            setSidebarHTML(r);
            setDeweyReady(true);
        });
    }

    const bookshelfCountRef = React.useRef(0);
    useEffect(() => {
        if (!bookshelves || !bookshelves.length) {
            return;
        }
        var grew = bookshelfCountRef.current > 0 && bookshelves.length > bookshelfCountRef.current;
        bookshelfCountRef.current = bookshelves.length;
        setBookshelfToAddTo(current => {
            // a shelf was just added, so select it
            if (grew) {
                return String(bookshelves[bookshelves.length - 1].bksId);
            }
            // otherwise keep the user's choice, falling back to the first shelf
            if (bookshelves.some(shelf => String(shelf.bksId) === current)) {
                return current;
            }
            return String(bookshelves[0].bksId);
        });
        // this is intended to set the bookshelf dropdown when you've just added your first bookshelf
        if (bookshelves.length === 1 && results?.hits?.hits) {
            var bktmp = {};
            results.hits.hits.forEach(h => {
                bktmp[h._source.product_id] = bookshelves[0].bksId;
            });
            setBookshelfSelect(current => ({ ...current, ...bktmp }));
        }
        closeModal("addBookshelf");
    }, [bookshelves]);

    const updateInBasketData = (prid, bsId, quantity, additive) => {
        if (!extraDataRef.current || !extraDataRef.current[prid]) {
            return;
        }
        var nbd = extraDataRef.current[prid].basketData;
        if (nbd.find(b => b.bsId == bsId)) {
            if (additive) {
                quantity += Number(nbd.find(b => b.bsId == bsId).biQty);
            }
            nbd.find(b => b.bsId == bsId).biQty = quantity;
        } else {
            nbd.push({ bsId: bsId, biQty: quantity });
        }
        var ned = { ...extraDataRef.current[prid], basketData: nbd };
        setExtraData({ ...extraDataRef.current, [prid]: ned });
    }

    const updateInWishlistData = (prid, wished) => {
        if (!extraDataRef.current || !extraDataRef.current[prid]) {
            return;
        }
        var nwd = { ...extraDataRef.current[prid], inWishlist: wished };
        setExtraData({ ...extraDataRef.current, [prid]: nwd });
    }

    const updateInBookshelfData = (prid, bksId, isin) => {
        if (!extraDataRef.current || !extraDataRef.current[prid]) {
            return;
        }
        var nbd = [];
        var added = false;
        extraDataRef.current[prid].bookshelfData.forEach(b => {
            if (isin && b.bksId == bksId) {
                nbd.push(b);
                added = true;
            } else if (b.bksId != bksId) {
                nbd.push(b);
            }
        });
        if (!added && isin) {
            nbd.push({ bksId: bksId });
        }
        var ned = { ...extraDataRef.current[prid], bookshelfData: nbd };
        setExtraData({ ...extraDataRef.current, [prid]: ned });
    }

    const updateInSharedBookshelfData = (prid, bksId, isin) => {
        if (!extraDataRef.current || !extraDataRef.current[prid]) {
            return;
        }
        var nbd = [];
        var added = false;
        extraDataRef.current[prid].sharedBookshelfData.forEach(b => {
            if (isin && b.bksId == bksId) {
                nbd.push(b);
                added = true;
            } else if (b.bksId != bksId) {
                nbd.push(b);
            }
        });
        if (!added && isin) {
            nbd.push({ bksId: bksId });
        }
        var ned = { ...extraDataRef.current[prid], sharedBookshelfData: nbd };
        setExtraData({ ...extraDataRef.current, [prid]: ned });
    }

    // first display only
    useEffect(() => {
        PubSub.sub("goToNextResult", (prid, basketId) => goToNextResultRef.current(prid, basketId));
        PubSub.sub("basketUpdate", (b, a, shelves, sharedShelves) => {
            const results = resultsRef.current;
            /* ONYL LIB AND FS BASKETS PRICING DEPEND ON ACTIVE BASKET SO PRICING DATA MUST BE RELOADED */
            if ((isLibraryUser() || isForSchoolBasket()) && extraDataRef.current && results && a !== activeBasketIdRef.current && results.hits && results.hits.total.value > 0) {
                // setExtraData(null);
                getExtraData(results);
            }
            fetchJson("/basket/addToBasketDropdownData").then(r => {
                setBaskets(r);
            });
            setActiveBasketId(a);
            setBookshelves(shelves);
            setSharedBookshelves(sharedShelves);
        });
        PubSub.sub("basketItemUpdate", (prid, bsId, quantity, additive = false) => {
            updateInBasketData(prid, bsId, quantity, additive);
        });
        PubSub.sub("addedToNewBookshelf", (prid, bksId) => {
            updateInBookshelfData(prid, bksId, true);
            const bookshelves = bookshelvesRef.current;
            if (bookshelves && bookshelves.length > 1) {
                setBookshelfSelect(current => ({ ...current, [prid]: bksId }));
            }
        });

        // $('body').on('click', '#addPageToBookshelf', addPageToBookshelf);
        $('body').on('change', '#addPageToBookshelfSelect', (e) => {
            // the button label is rendered from bookshelfToAddTo, so only the modal is handled here
            if (e.currentTarget.options[e.currentTarget.selectedIndex].value == "new") {
                openModal("addBookshelf");
                return;
            }
        });

        PubSub.sub("addPageToBookshelf", doAddPageToBookshelf);

        // delegated so that re-rendering the same filter tags doesn't stack up extra listeners on them
        $('body').on('click', '.filterTag.removable', function () {
            filterTagClickRef.current(this);
        });

        var formData = new FormData();
        const urlAppliedFilters = document.querySelector("[name='urlAppliedFilters']");
        var searchString = "";

        // formData.append("searchTerm", params.get("searchTerm"));
        // formData.append("searchType", params.get("searchType"));
        if (urlAppliedFilters && urlAppliedFilters.value) {
            searchString = urlAppliedFilters.value;
        }

        if (bookpage) {
            formData.append("searchTerm", bookpageIsbn);
            formData.append("searchType", "isbn");
            formData.append("exactMatch", 1);
        } else if (wishlist) {
            formData.append("basketFilter", wishlist);
        } else if (searchString) {
            formData.append("urlAppliedFiltersJson", searchString);
        }

        fetchJson("/search/awardsData").then(r => {
            setAwardsData(r);
        });
        fetchJson("/search/keywordsData").then(r => {
            setKeywordsData(r);
        });
        fetchJson("/search/bestsellersData").then(r => {
            setBestsellersData(r);
        });
        fetchJson("/search/internalKeywordsData").then(r => {
            setInternalKeywordsData(r);
        });
        fetchStaticJson("/assets/json/bicdata.json").then(r => {
            setBicData({ ...r, loaded: true, error: false });
        }).catch(() => {
            setBicData({ loaded: true, error: true });
        });
        fetchStaticJson("/assets/json/allthema.json").then(r => {
            setThemaData({ ...r, loaded: true, error: false });
        }).catch(() => {
            setThemaData({ loaded: true, error: true });
        });
        // fetchJson("/basket/addToBasketDropdownData").then(r => {
        //     setBaskets(r);
        // });

        getBookBands();

        $('body').on('click', '.checkMarkInput', function (event) {
            var checkMarkIds = ['readCheckbox', 'availableCheckbox', 'stockCheckbox', 'excludeOrdered'];
            checkMarkIds.forEach(function (element) {
                if (event.currentTarget.id === element) {
                    applyFilters();
                }
            });
        });

        $('body').on('click', ".hasModal h5", function (e) {
            // Aggregation feature disabled:
            // if (!$(this).next(".filterModal").hasClass("open")) {
            //     if ($(this).parent().attr("sfid") == "1") {
            //         getAggregation("productcategorylinks", formData, $(this));
            //     } else if ($(this).parent().attr("sfid") == "31") {
            //         getAggregation("category", formData, $(this));
            //     } else if ($(this).parent().attr("sfid") == "8") {
            //         getAggregation("genre", formData, $(this), "uc");
            //     }
            // }

            // Finds correct top by getting half of element and taking of half the height of the section
            // topHeight = parseInt(($(this).next('.filterModal').outerHeight() / 2)-24);
            // $(this).next('.filterModal').css('top', -topHeight);

            $('.filterModal.open').not($(this).next()).siblings('h5').children('i').toggleClass('open');
            toggleVal($('.filterModal.open').not($(this).next()).siblings('.sectionOpen'));
            $('.filterModal.open').not($(this).next()).removeClass('open');
            $(this).find('i').toggleClass('open');
            $(this).next('.filterModal').toggleClass('open');
            toggleVal($(this).siblings('.sectionOpen'));
        });

        $('body').on('change', '.searchHeadBar input:not(#allBooksSelected), .searchHeadBar select', function (e) {
            if ($(this).hasClass('displayFrom')) {
                $('.displayFrom').val($(this).val());
            }
            if ($(this).hasClass('sort')) {
                $('.displayFrom').val(1);
                var $sortItem = $(this).parents('.sortItem');
                var keyNumber = $sortItem.attr('keyNumber');

                $('.sortItem[keyNumber=' + keyNumber + ']').find('.sort').val($(this).val());
                var sort = $(this).val();

                var $sortInput = $sortItem.find('.sortOrderInput');

                $sortInput.val(getInitialSortOrder(sort));

                var $sortItemList = $(this).parents('.sortItemList');

                updateSortItemsJson($sortItemList);
                applyFilters();
            }
        });

        $('body').on('click', '.sortOrder', function (e) {
            e.stopPropagation();
            var $sortOrderInput = $(this).find('.sortOrderInput');
            var sortOrderValue = $sortOrderInput.val();


            if (sortOrderValue == "DESC") $sortOrderInput.val('ASC');
            else $sortOrderInput.val('DESC');

            var $sortItemList = $(this).parents('.sortItemList')

            updateSortItemsJson($sortItemList);
            applyFilters();
        });

        // Remove selected items from wishlist
        $('body').on('click', '#removedSelectedFromWishlist', function () {
            var checkedInputs = $('.wishListItems .checkMarkInput:checked');
            var checkedItems = checkedInputs.parents('.productContainer');
            var numberCheckedItems = checkedItems?.length;
            var totalItems = $('.productImageContainer').length;
            const requests = checkedItems.map(function () {
                return $.ajax({
                    method: 'POST',
                    cache: false,
                    url: '/widgets/ajax/ajax.basket.actions.php',
                    data: {
                        action: 'removeFromWishList',
                        prid: $(this).data('prid'),
                    }
                });
            }).get();

            // only refresh once every item has been removed (the list is rendered by React, so it's left to re-render rather than removing items here)
            $.when(...requests).done(function () {
                if (totalItems - numberCheckedItems == 0) {
                    location.reload();
                } else {
                    applyFilters();
                }
            });
        });

        // if we are on any normal search results page then the useEffect hook in QuickSearchContainer will trigger the actual search
        if (bookpage || wishlist || at) {
            doSearch(formData, true);
            loadFilterSidebar(formData);
        }

        return () => {
            PubSub.clearsub("goToNextResult");
            PubSub.clearsub("basketUpdate");
            PubSub.clearsub("basketItemUpdate");
            PubSub.clearsub("addedToNewBookshelf");
        }
    }, []);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else { // only do this when page or limit change, not on first mount
            doFilterSearch();
            Cookies.set('limitCountNew', limit, { sameSite: "Strict" });
        }
    }, [limit]);

    const goToSearch = (formData, replace=false) => {
        setResultsLoaded(false);
        fetchJson("/search/postFiltersToString", formData).then(r => {
            let currentPageUrl = window.location.href;
            let urlArray = currentPageUrl.split('/');
            let currentSearchString = urlArray[urlArray.length-1];

            if (r.searchString !== currentSearchString) {
                if (wishlist) {
                    // this is necessary to get rid of the stuff specific to the wishlist page
                    window.location.href = `/search-results/${r.searchString}`;
                } else if ($('.embeddedSearchPage').length > 0) {
                    // this is necessary for embedded/custom search pages
                    doSearchStringSearch(r.searchString, true);
                } else {
                    navigate(`/search-results/${r.searchString}`, {replace: replace});
                }
            } else {
                setResultsLoaded(true);
            }
        });
    }

    const doSearchStringSearch = (search, reloadSidebar=false) => {
        let formData = new FormData();
        formData.append("urlAppliedFiltersJson", search);
        if (searchParams.get("s")) {
            formData.append("isShortened", "1");
        }
        doSearch(formData, false, true);
        if (reloadSidebar) {
            loadFilterSidebar(formData);
        }
    }

    const doSearchTermSearch = (searchTerm, searchType) => {
        var formData = new FormData();
        formData.append("searchTerm", searchTerm);
        formData.append("searchType", searchType);
        setIds(null);
        // doSearch(formData, true);
        goToSearch(formData);
        loadFilterSidebar(formData);
    }

    const doFilterSearch = () => {
        var formData = new FormData(document.getElementById("searchForm"));

        // Reset the page to 1 on aeach new filter search
        formData.set("page", 1);

        if (at) {
            doSearch(formData, true);
        } else {
            goToSearch(formData);
        }
    }

    const doCustomSearch = (filters) => {
        var formData = new FormData();
        filters.forEach(f => {
            formData.append(f.filter, f.value);
        });
        setIds(null);
        goToSearch(formData);
        // doSearch(formData, true);
        loadFilterSidebar(formData);
    }

    // sts is true when doing a search string search
    const doSearch = (formData, isnew = false, sts = false) => {
        const isFirst = isInitialMount.current;

        const path = window.location.pathname.split("/");

        setResultsLoaded(false);

        fetchJson("/search/quick", formData).then(r => {
            const hits = r.data?.hits?.hits || [];
            const hitCount = r.data?.hits?.total?.value || 0;

            var newSearchString;
            if (!formData.get("urlAppliedFiltersJson") || !isnew) {
                newSearchString = r.searchString;
            } else {
                newSearchString = formData.get("urlAppliedFiltersJson");
            }

            // React 17 doesn't batch state updates made outside its own event handlers, so without this
            // every setter below would re-render the whole results list on its own
            ReactDOM.unstable_batchedUpdates(() => {
                setOffset(Number(r.offset));
                setResults(r.data);
                setPage(Number(r.page));
                setDisplayFrom(Number(r.displayFrom));
                setSuggestions(r.suggestions);
                setDidyoumean(r.didyoumean);
                setFurniture(r.furniture);
                setFurnitureCount(r.furnitureCount);
                setBooleanFilters(r.booleanFilters);

                if (r.overrideTotal) {
                    setTotal(r.overrideTotal);
                } else if (r.data?.hits) {
                    setTotal(r.data.hits.total.value);
                } else {
                    setTotal(null);
                }

                if(r.missingIsbns) {
                    setMissingIsbns(r.missingIsbns);
                }

                if (isnew) {
                    setUndoStack([...undoStackRef.current, r.searchString]);
                    setRedoStack([]);
                }

                setSearchString(newSearchString);

                setFilterTags(r.tags);
                setBooleanTags(r.booleanTags);
                // const bf = document.getElementById("structuredBooleanFilters");
                // if (document.getElementById("appliedFilters")) {
                //     document.getElementById("appliedFilters").innerHTML = r.tags;
                // }
                // if (bf && r.booleanTags) {
                //     bf.innerHTML = r.booleanTags;
                //     bf.style.display = "block";
                // } else if (bf) {
                //     bf.style.display = "none";
                // }

                setSortHTML(r.sort);
                // $(".sortItemList").html(r.sort);
                // sortItemsInit();

                // if only one result, go straight to product view, but not on the awards timeline or wishlist page
                if (hitCount === 1 && !at && !wishlist) {
                    if(formData.get("searchType") == "isbn" && formData.get("exactMatch") == "1") {
                        // this set up means we are looking at a single book intentionally so don't need a search string to be able to return to listing, makes url look nicer
                        goToResult(hits[0]._source.id);
                    } else {
                        goToResult(hits[0]._source.id, newSearchString);
                    }
                } else if (!sts) {
                    if (viewingResultRef.current !== null && hits.length > 0) {
                        const i = viewPreviousRef.current ? (hits.length - 1) : 0;
                        goToResult(hits[i]._source.id, newSearchString);
                        setViewPrevious(false);
                    }
                }

                setResultsLoaded(true);
            });

            // everything below works on the DOM, so it has to run after the batch above has rendered

            localStorage.setItem('searchString', r.searchString);
            localStorage.setItem('page', r.page);

            if (!at && !wishlist && !document.getElementById("awardsTimeline")) {
                if ($('.embeddedSearchPage').length > 0) {
                    $('a.openEditedSearch').remove();
                    $('.pagination .info').append('<a class="openEditedSearch" target="_blank" href="/search-results/' + r.searchString + '" title="Open edited search in a new tab"><i class="fas fa-external-link"></i></a>');
                } else if (path[1] != "book-page") {
                    // history.pushState("", "", "/search-results/" + r.searchString);
                }
            }
            $(window).scrollTop(0);

            // preload ordering grid
            if (hitCount > 0) {
                const firstResult = hits[0]._source.product_id;
                loadOrderingGrid(null, firstResult);
            }

            // if there are results, let's get the extra data (price, order history etc)
            if (hitCount > 0) {
                const ed = extraDataRef.current;

                const items = hits.filter(hit => ed === null || !ed[hit._source.product_id]).reduce((acc, current) => {
                    acc[current._source.product_id] = {
                        dbdqtyheld: current._source.dbdqtyheld
                    };
                    return acc;
                }, {});

                fetchJson("/product/extraData", {
                    items: items
                }).then(extra => {
                    const orig = ed ? ed : {};
                    setExtraData({ ...orig, ...extra });
                });
            }

            $('.filterTag[filter="isbnList"] .removeFilterTag').hide();
            $('.filterTag[filter="isbnList"]').removeClass('removable');
            $('.booleanFilterList .removable').removeClass("removable");
            $('.booleanFilterList .removeFilterTag').remove();

            // "save and go to next" from the last result on a page carries on with the first result of the new page
            if (nextPageOrderingGridRef.current !== null) {
                const basketId = nextPageOrderingGridRef.current;
                nextPageOrderingGridRef.current = null;
                const firstHit = hits[0];
                if (firstHit) {
                    PubSub.pub("addProductToBasketWithMemory", basketId, firstHit._source.product_id, null, true);
                }
            }
        });
    }

    useEffect(() => {
        if (!baskets || results.length == 0 || !sidebarLoaded || !results.hits.hits || results.hits.hits.length == 0) {
            return;
        }
        // initialise the basket and bookshelf dropdowns
        var bstmp = basketSelect;
        var bktmp = bookshelfSelect;
        results.hits.hits.forEach(h => {
            bstmp[h._source.product_id] = activeBasketId;
            if (bookshelves?.length > 0) {
                var defaultBookshelf;
                if (document.querySelector('[name="bookshelfId"]')) {
                    // this is if we're on a bookshelf filter search
                    defaultBookshelf = document.querySelector('[name="bookshelfId"]').value;
                }
                if (!defaultBookshelf) {
                    defaultBookshelf = bookshelves[0].bksId;
                }
                bktmp[h._source.product_id] = defaultBookshelf;
            } else {
                bktmp[h._source.product_id] = "new";
            }
        });

        setBasketSelect({ ...bstmp });
        setBookshelfSelect({ ...bktmp });
    }, [activeBasketId, results, sidebarLoaded, baskets]);

    const addPageToBookshelf = (e) => {
        const addPageToBookshelfSelect = document.getElementById("addPageToBookshelfSelect");

        /* const limitValue = document.querySelectorAll(".productContainer").length;
        const page = document.getElementById("pageNumber").value; */
        const bksId = addPageToBookshelfSelect.options[addPageToBookshelfSelect.selectedIndex].value;

        if (bksId == "new") {
            // openModal("addBookshelf").then(() => {
            // addPageToBookshelf();
            // });
            return;
        }
        doAddPageToBookshelf(bksId);
    }

    const doAddPageToBookshelf = (bksId) => {
        notifyLoading();

        const results = resultsRef.current;
        var ids = results.hits.hits.map(hit => hit._source.product_id);
        fetchJson("/bookshelves/addMultiple/" + bksId, {
            items: ids
        }).then(() => {
            var newBookshelfSelect = {};

            ids.forEach(id => {
                updateInBookshelfData(id, bksId, true);
                newBookshelfSelect[id] = bksId;
            });
            setBookshelfSelect(current => ({ ...current, ...newBookshelfSelect }));

            stopNotifyLoading();
        });
    }

    const getExtraData = (results) => {
        if (results && results.hits && results.hits.total.value > 0) {
            const items = results.hits.hits.reduce((acc, current) => {
                acc[current._source.product_id] = {
                    dbdqtyheld: current._source.dbdqtyheld
                };
                return acc;
            }, {});

            fetchJson("/product/extraData", {
                items: items
            }).then(extra => {
                setExtraData(extra);
            });
        }
    }

    const undo = () => {
        const op = undoStack.pop();
        if (!op) {
            return;
        }
        setRedoStack([...redoStack, op]);
        const last = undoStack[undoStack.length - 1];
        var formData = new FormData();
        formData.append("urlAppliedFiltersJson", last);
        doSearch(formData);
        loadFilterSidebar(formData);
    }

    const redo = () => {
        const op = redoStack.pop();
        setUndoStack([...undoStack, op]);
        var formData = new FormData();
        formData.append("urlAppliedFiltersJson", op);
        doSearch(formData);
        loadFilterSidebar(formData);
    }

    const getIds = () => {
        var formData = new FormData();
        formData.append("urlAppliedFiltersJson", searchString);
        formData.append("idsonly", 1);

        fetchJson("/search/quick", formData).then(r => {
            setIds(r.ids);
        });
    }

    // useEffect(() => {
    //     if (isInitialMount.current || !results.hits || !results.hits.hits) {
    //         return;
    //     }

    // }, [results]);

    const goToResult = (viewingResult, newSearchString="") => {
        // if (viewingResult == null || isInitialMount.current) {
        //     isInitialMount.current = false;
        //     return;
        // }
        if (!newSearchString) {
            newSearchString = searchString;
        }

        if (!resultsRef.current || !resultsRef.current.hits || total == 0) {
            return;
        }

        const elasticData = resultsRef.current.hits.hits.find(h => h._source.id == viewingResult)._source;
        let URL;

        if (elasticData.authors?.length > 0) {
            const parseAuthorSlug = (title) => {
                const commaIdx = title.indexOf(',');
                const lastName = title.substring(0, commaIdx);
                const firstName = title.substring(commaIdx + 1).trim().replace(/ +/g, '-');
                return slugify(`${firstName}-${lastName}`);
            };

            const authorSlug = elasticData.authors.slice(0, 2).map(a => parseAuthorSlug(a.title)).join('-and-');

            const titleSlug = slugify(`${elasticData.title}`.split(' ').join('-'));
            let prTitleSlug = decodeHTML(titleSlug);
            if (prTitleSlug.includes('/')) {
                prTitleSlug = encodeURIComponent(prTitleSlug); // Intended to prevent Apache "404 Not Found" redirect?
            }
            URL = `/book-page/${encodeURIComponent(viewingResult)}/${encodeURIComponent(authorSlug)}/${encodeURIComponent(prTitleSlug)}`;
        } else {
            URL = `/book-page/${encodeURIComponent(viewingResult)}`;
        }

        if (newSearchString) {
            const u = new URLSearchParams();
            u.append("search", newSearchString);
            if (searchParams.get("s")) {
                u.append("s", "1");
            }
            if (at) {
                u.append("at", "1");
            }
            URL += ("?" + u.toString());
        }

        // navigating to the URL is what triggers the relevant state updates. (previously it was the other way around)
        navigate(URL);
    }

    const searchViewType = getSearchViewType(updatedGridView);

    const index = (results && results.hits && results.hits.hits && viewingResult !== null) ? results.hits.hits.findIndex(h => h._source.id == viewingResult) : null;

    const nextResult = (prid = null) => {
        const rs = resultsRef.current;
        var i;
        if (prid && rs.hits) { // this is if we're not viewing a result
            i = rs.hits.hits.findIndex(h => h._source.product_id == prid);
        } else {
            i = (rs.hits && viewingResultRef.current !== null) ? rs.hits.hits.findIndex(h => h._source.id == viewingResultRef.current) : null;
        }
        setViewPrevious(false);

        if ((i + 1) >= rs.hits?.hits?.length) {
            changePage((pageRef.current) + 1);
        } else {
            goToResult(rs.hits.hits[i + 1]._source.id);
        }
    }

    // published by the ordering grid's "save and go to next" button
    const goToNextResult = (prid, basketId) => {
        // viewing a book page so move on to the next book page
        if (viewingResultRef.current !== null) {
            nextResult(prid);
            return;
        }

        // on the results list so open the next result's ordering grid in the same basket
        const hits = resultsRef.current?.hits?.hits;
        const i = hits ? hits.findIndex(h => h._source.product_id == prid) : -1;
        if (i === -1 || (offset + i + 1) >= total) {
            return;
        }
        if ((i + 1) < hits.length) {
            PubSub.pub("addProductToBasketWithMemory", basketId, hits[i + 1]._source.product_id, null, true);
        } else {
            nextPageOrderingGridRef.current = basketId;
            changePage(pageRef.current + 1);
        }
    }
    // the subscription is made once on mount, so keep it pointing at the latest render's handler
    goToNextResultRef.current = goToNextResult;
    filterTagClickRef.current = (el) => {
        removeFilter(el);
        applyFilters();
    };

    var slClasses = "column searchSection " + searchViewType + "View" + (wishlist ? " wishListItems" : "") + (updatedGridView ? " updatedGridView" : "");
    // if (!wishlist) {
    //     slClasses += " fiveSixth";
    // }

    const searchSaved = () => {
        var channel = null;
        if (typeof BroadcastChannel != "undefined") {
            channel = new BroadcastChannel("stockSearchChannel");
        }
        $(".pagination .info").append('<span class="searchSavedMessage petersPink">&nbsp;Saved</span>');
        if (channel) {
            channel.postMessage({
                refresh: 'savedSearch'
            });
        }
        setTimeout(function () {
            $('.searchSavedMessage').fadeOut(function () {
                $(this).remove();
            });
        }, 2000);
    }

    return (
        <SearchContext.Provider value={{ extraData, limit, offset, page, displayFrom, setLimit, changePage, doSearchTermSearch, doCustomSearch, doSearchStringSearch, baskets, activeBasketId, bookshelves, awardsData, keywordsData, bestsellersData, bestsellersByProduct, internalKeywordsData, bicData, themaData, viewingResult, setViewingResult, viewingResultRef, goToResult, applyFilters, sidebarLoaded, ids, getIds, getIds, wishlist, deweyReady, basketSelect, bookshelfSelect, setBasketSelect, setBookshelfSelect, bookshelfToAddTo, setBookshelfToAddTo, updateInBookshelfData, sharedBookshelves, updateInSharedBookshelfData, addPageToBookshelf, updateInWishlistData, filterTags, booleanTags, missingIsbns, searchString, sortHTML, updatedGridView }}>
            <AddEntityModal id="saveSearchModal" heading="Save search" route="/savedSearch" callback={searchSaved} extraData={{ query: searchString }} />
            <form id="searchForm" style={{ position: "relative" }}>
                {booleanFilters && <textarea id="booleanFilters" name="booleanFilters" readOnly style={{ display: "none" }} value={booleanFilters}>{booleanFilters}</textarea>}
                {isEntitled() && <ISBNModal />}
                {(!isLibraryUser() || isForSchoolBasket()) && <AddItemsToBasketModal />}
                {wishlist && <input name="basketFilter" value={wishlist} type="hidden" />}
                {wishlist && <input name="page" type="hidden" defaultValue={page} />}

                {(!sidebarLoaded || !resultsLoaded) && <LoadingSpinner overlay={true} />}
                <Routes>
                    <Route path="/book-page">
                        <Route path=":isbn/*" element={!!results.hits ? <BookPage results={results} extraData={extraDataRef.current} bicCodes={bicData} themaCodes={themaData} bindings={bindings} broadbindings={broadbindings} keywords={keywordsData} languages={languages} nextResult={nextResult} setViewPrevious={setViewPrevious} total={total} searchString={searchString} /> : null} />
                    </Route>
                    <Route path="/furniture/search" element={<FurnitureSearch results={results} slClasses={slClasses} suggestions={suggestions} didyoumean={didyoumean} sidebarLoaded={sidebarLoaded} viewingResult={viewingResult} furniture={furniture} furnitureCount={furnitureCount} total={total} undo={undo} redo={redo} undoStack={undoStack} redoStack={redoStack} />} />
                    <Route path="/wishlist/view" element={<BookWishlistResults results={results} slClasses={slClasses} total={total} undo={undo} redo={redo} undoStack={undoStack} redoStack={redoStack} />} />
                    <Route path="/search-results/:search" element={<QuickSearchContainer suggestions={suggestions} didyoumean={didyoumean} undo={undo} redo={redo} undoStack={undoStack} redoStack={redoStack} total={total} furniture={furniture} furnitureCount={furnitureCount} slClasses={slClasses} results={results} sidebarHTML={sidebarHTML} index={index} />} />
                    <Route path="/awards-timeline/*" element={<AwardsTimeline suggestions={suggestions} didyoumean={didyoumean} undo={undo} redo={redo} undoStack={undoStack} redoStack={redoStack} total={total} furniture={furniture} furnitureCount={furnitureCount} slClasses={slClasses} results={results} sidebarHTML={sidebarHTML} index={index} />} />
                    <Route path="*" element={<CustomSearchPage suggestions={suggestions} didyoumean={didyoumean} undo={undo} redo={redo} undoStack={undoStack} redoStack={redoStack} total={total} furniture={furniture} furnitureCount={furnitureCount} slClasses={slClasses} results={results} sidebarHTML={sidebarHTML} index={index} doSearch={doSearch} loadFilterSidebar={loadFilterSidebar} />} />
                </Routes>
            </form>
        </SearchContext.Provider>
    )
}

const AwardsTimeline = ({ suggestions, didyoumean, undo, redo, undoStack, redoStack, total, furniture, furnitureCount, slClasses, results, sidebarHTML, index }) => {
    return <QuickSearchContainer suggestions={suggestions} didyoumean={didyoumean} undo={undo} redo={redo} undoStack={undoStack} redoStack={redoStack} total={total} furniture={furniture} furnitureCount={furnitureCount} slClasses={slClasses} results={results} sidebarHTML={sidebarHTML} index={index} />
}

// this component is used when you do a header search, or a search with just GET variables such as ?thema=AB
// or if you just go to /search-results
const CustomSearchPage = ({ suggestions, didyoumean, undo, redo, undoStack, redoStack, total, furniture, furnitureCount, slClasses, results, sidebarHTML, index, doSearch, loadFilterSidebar }) => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [haveSearch, setHaveSearch] = useState(false);
    const { setViewingResult, doSearchStringSearch, doSearchTermSearch } = useContext(SearchContext);

    useEffect(() => {
        const urlAppliedFilters = document.querySelector("[name='urlAppliedFilters']");
        if (urlAppliedFilters && urlAppliedFilters.value) {
            setViewingResult(null);
            doSearchStringSearch(urlAppliedFilters.value, true);
            setHaveSearch(true);
        } else {
            var formData = new FormData();
            const params = new URLSearchParams(window.location.search);
            var p = 0;
            for (const [k, v] of params) {
                formData.append(k, v);
                if (k == "thema") {
                    formData.append("filters[thema][code]", v);
                }
                p++;
            }
            if(p==0) {
                let search = window.location.pathname.split('/')
                if(search[2] == "author" || search[2] == "series") {
                    formData.append("searchType", search[2]);
                    formData.append("searchTerm", decodeURIComponent(search[3]));
                }
            }
            // if there are no GET variables to inform the search, we'll look in local storage and go to the most recent search
            if (!p && localStorage.getItem('searchString') && window.location.pathname == "/search-results") {
                navigate(`/search-results/${localStorage.getItem('searchString')}`);
            } else {
                // otherwise we'll go to the desired search
                setViewingResult(null);
                doSearch(formData, true);
                loadFilterSidebar(formData);
                setHaveSearch(true);
            }
        }
    }, [searchParams]);

    if (!haveSearch) {
        return null;
    }

    return <QuickSearchContainer suggestions={suggestions} didyoumean={didyoumean} undo={undo} redo={redo} undoStack={undoStack} redoStack={redoStack} total={total} furniture={furniture} furnitureCount={furnitureCount} slClasses={slClasses} results={results} sidebarHTML={sidebarHTML} index={index} />
}

// this component is used when we have a search string in the address bar
const QuickSearchContainer = ({ suggestions, didyoumean, undo, redo, undoStack, redoStack, total, furniture, furnitureCount, slClasses, results, sidebarHTML, index }) => {
    const { limit, offset, wishlist, sidebarLoaded, page, viewingResultRef, setViewingResult, applyFilters, searchString, doSearchStringSearch } = useContext(SearchContext);
    const { search } = useParams();

    const initTitle = document.title;

    useEffect(() => {
        setViewingResult(null);
        document.title = initTitle;
        if (!search || search == decodeURIComponent(searchString) || search == searchString) {
            return;
        }

        doSearchStringSearch(search, true);
    }, [search]);

    useEffect(() => {
        setViewingResult(null);
        if (index) {
            var anchor = $(".productContainer.searchBox").get(index);
            $('html,body').animate({
                scrollTop: anchor.offsetTop
            }, 500);
        }
    }, [searchString]);

    useEffect(() => {
        document.getElementById("searchFilters").innerHTML = sidebarHTML;
        document.querySelectorAll(".filterApply").forEach(el => {
            el.addEventListener('click', applyFilters);
        });
        $('.toClose').trigger('click');

        if ($('ul[category="ukslc"]').length) {
            var ukslcCodesJson = JSON.parse($("#ukslcJson").val());

            // var ukslcSelectedAge = '<?=$filters["ukslc"]["age"]["value"];?>';
            // var ukslcSelectedAudience = '<?=$filters["ukslc"]["audience"]["value"];?>';
            // var ukslcSelectedTreatment = '<?=$filters["ukslc"]["treatment"]["value"];?>';
            // var ukslcSelectedSubject = '<?=$filters["ukslc"]["subject"]["value"];?>';

            var selectorUkslcAge = new Selectr('#ukslcAge', ukslcCodesJson.Age);
            // selectorUkslcAge.setValue(ukslcSelectedAge);

            var selectorUkslcAudience = new Selectr('#ukslcAudience', ukslcCodesJson.Audience);
            // selectorUkslcAudience.setValue(ukslcSelectedAudience);

            var selectorUkslcTreatment = new Selectr('#ukslcTreatment', ukslcCodesJson.Treatment);
            // selectorUkslcTreatment.setValue(ukslcSelectedTreatment);

            var selectorUkslcSubject = new Selectr('#ukslcSubject', ukslcCodesJson.Subject);
            // selectorUkslcSubject.setValue(ukslcSelectedSubject);

            if ($('#ukslcInterest').length && ukslcCodesJson.Interest) {
                var selectorUkslcInterest = new Selectr('#ukslcInterest', ukslcCodesJson.Interest);
            }
        }

        if ($('.searchableSelect').length > 0) {
            $('.searchableSelect').each(function () {
                var id = $(this).attr('id')
                new Selectr(document.getElementById(id));

                // Handle multiple choices [WIP -> CURRENTLY USED FOR "AWARDS" ONLY]
                var classNames = $(this).attr('class');
                if(classNames.includes('multiChoice')) {
                    $(this).on('change', function(){
                        document.querySelectorAll('[id^="awardName"]').forEach(function(award) {
                            $(award).prop('checked', false);
                        });
                        let selectedOptions = $(this).val();
                        for (let i in selectedOptions) {
                            $('input[id="awardName' + selectedOptions[i] + '"]').prop('checked', true);
                        }
                    })
                }
            })
        }
        const path = window.location.pathname.split("/");
        const at = (path[1] == 'awards-timeline');
        if (!at) {
            if (typeof slidersInit === "function") {
                slidersInit();
            }
        }
        $('#awardsTimeline .award').on('click', function (e) {
            var $award = $(e.target);
            if (!$award.hasClass("award")) {
                $award = $(e.target).parents(".award");
            }
            var awId = $award.data('id');
            var winners = $award.data('winners');
            var shortlist = $award.data('shortlist');
            var group = $('#awardsTimeline').data('group');

            $('#awardFilter').val(awId);
            $('#awardWinnersFilter').val(winners);
            $('#awardShortlistedFilter').val(winners ? 0 : shortlist);

            $('#awardsTimeline .selected').removeClass("selected");
            $award.addClass("selected");

            history.replaceState('', '', '/awards-timeline/' + (group ? group : "0") + '/' + awId);

            applyFilters();
        });

        if ($('#awardsTimeline').length) {
            $('.filterTag').removeClass("removable");
            $('.filterTag .removeFilterTag').remove();
        }

        if ($('#awardsTimeline').hasClass("unfiltered")) {
            $('#searchFilters').addClass("unfiltered");
        }

    }, [sidebarHTML]);

    return <div className="search container">
        {total > 0 && <ViewControls avgrrp={results.aggregations.avgrrp.value} total={total} /> }
        <div className="columns">
            <input id="hamburgerMenuFilterBar" className="hamburgerInput" type="checkbox" />
            <div className="filterBarOverlay"></div>
            {!wishlist && <div id="filterSidebarContainer">
                <div id="filterSidebar" className="column mobileSidebar">
                    <label className="hamburger" htmlFor="hamburgerMenuFilterBar">
                        <div className="hamburgerBox">
                            <span className="hamburgerInner"></span>
                        </div>
                        <div className="hamburgerText">Filter</div>
                    </label>
                    <div className="filterBar">
                        {isEntitled() && !document.getElementById("awardsTimeline") && <Suggestions suggestions={suggestions} results={results} />}
                        {!sidebarLoaded && <span>Loading...</span>}
                        <div id="searchFilters"></div>
                    </div>
                </div>
            </div>}
            <div id="searchList" className={slClasses}>
                {furniture && <FurnitureResults furniture={furniture} furnitureCount={furnitureCount} />}
                <Results didyoumean={didyoumean} results={results} total={total} undo={undo} redo={redo} undoStack={undoStack} redoStack={redoStack} />
            </div>
        </div>
    </div>
}

// opting in to the v7 behaviour early silences React Router's warnings - all navigation here uses absolute paths, so the splat path change doesn't affect it
ReactDOM.render(<BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}><QuickSearch /></BrowserRouter>, document.getElementById("quickSearch"));